// Complete Nigeria States, LGAs and Areas data

export interface Area {
  id: string;
  name: string;
}

export interface LGA {
  id: string;
  name: string;
  areas: Area[];
}

export interface State {
  id: string;
  name: string;
  capital: string;
  lgas: LGA[];
}

export const nigeriaStates: State[] = [
  {
    id: "abia",
    name: "Abia State",
    capital: "Umuahia",
    lgas: [
      { id: "aba-north", name: "Aba North", areas: [{ id: "eziama", name: "Eziama" }, { id: "uratta", name: "Uratta" }, { id: "ogbor-hill", name: "Ogbor Hill" }] },
      { id: "aba-south", name: "Aba South", areas: [{ id: "aba-main", name: "Aba Town" }, { id: "port-harcourt-road", name: "Port Harcourt Road" }, { id: "faulks-road", name: "Faulks Road" }] },
      { id: "arochukwu", name: "Arochukwu", areas: [{ id: "arochukwu-main", name: "Arochukwu" }] },
      { id: "bende", name: "Bende", areas: [{ id: "bende-main", name: "Bende" }] },
      { id: "ikwuano", name: "Ikwuano", areas: [{ id: "ikwuano-main", name: "Ikwuano" }] },
      { id: "isiala-ngwa-north", name: "Isiala Ngwa North", areas: [{ id: "isiala-main", name: "Isiala Ngwa" }] },
      { id: "isiala-ngwa-south", name: "Isiala Ngwa South", areas: [{ id: "isiala-south", name: "Isiala Ngwa South" }] },
      { id: "isuikwuato", name: "Isuikwuato", areas: [{ id: "isuikwuato-main", name: "Isuikwuato" }] },
      { id: "obi-ngwa", name: "Obi Ngwa", areas: [{ id: "obi-ngwa-main", name: "Obi Ngwa" }] },
      { id: "ohafia", name: "Ohafia", areas: [{ id: "ohafia-main", name: "Ohafia" }] },
      { id: "osisioma", name: "Osisioma Ngwa", areas: [{ id: "osisioma-main", name: "Osisioma" }] },
      { id: "ugwunagbo", name: "Ugwunagbo", areas: [{ id: "ugwunagbo-main", name: "Ugwunagbo" }] },
      { id: "ukwa-east", name: "Ukwa East", areas: [{ id: "ukwa-east-main", name: "Ukwa East" }] },
      { id: "ukwa-west", name: "Ukwa West", areas: [{ id: "ukwa-west-main", name: "Ukwa West" }] },
      { id: "umuahia-north", name: "Umuahia North", areas: [{ id: "umuahia-main", name: "Umuahia" }, { id: "ibeku", name: "Ibeku" }] },
      { id: "umuahia-south", name: "Umuahia South", areas: [{ id: "apumiri", name: "Apumiri" }] },
      { id: "umu-nneochi", name: "Umu Nneochi", areas: [{ id: "nneochi", name: "Nneochi" }] },
    ],
  },
  {
    id: "adamawa",
    name: "Adamawa State",
    capital: "Yola",
    lgas: [
      { id: "demsa", name: "Demsa", areas: [{ id: "demsa-main", name: "Demsa" }] },
      { id: "fufure", name: "Fufure", areas: [{ id: "fufure-main", name: "Fufure" }] },
      { id: "ganye", name: "Ganye", areas: [{ id: "ganye-main", name: "Ganye" }] },
      { id: "girei", name: "Girei", areas: [{ id: "girei-main", name: "Girei" }] },
      { id: "gombi", name: "Gombi", areas: [{ id: "gombi-main", name: "Gombi" }] },
      { id: "guyuk", name: "Guyuk", areas: [{ id: "guyuk-main", name: "Guyuk" }] },
      { id: "hong", name: "Hong", areas: [{ id: "hong-main", name: "Hong" }] },
      { id: "jada", name: "Jada", areas: [{ id: "jada-main", name: "Jada" }] },
      { id: "lamurde", name: "Lamurde", areas: [{ id: "lamurde-main", name: "Lamurde" }] },
      { id: "madagali", name: "Madagali", areas: [{ id: "madagali-main", name: "Madagali" }] },
      { id: "maiha", name: "Maiha", areas: [{ id: "maiha-main", name: "Maiha" }] },
      { id: "mayo-belwa", name: "Mayo-Belwa", areas: [{ id: "mayo-belwa-main", name: "Mayo-Belwa" }] },
      { id: "michika", name: "Michika", areas: [{ id: "michika-main", name: "Michika" }] },
      { id: "mubi-north", name: "Mubi North", areas: [{ id: "mubi-main", name: "Mubi" }] },
      { id: "mubi-south", name: "Mubi South", areas: [{ id: "mubi-south", name: "Mubi South" }] },
      { id: "numan", name: "Numan", areas: [{ id: "numan-main", name: "Numan" }] },
      { id: "shelleng", name: "Shelleng", areas: [{ id: "shelleng-main", name: "Shelleng" }] },
      { id: "song", name: "Song", areas: [{ id: "song-main", name: "Song" }] },
      { id: "toungo", name: "Toungo", areas: [{ id: "toungo-main", name: "Toungo" }] },
      { id: "yola-north", name: "Yola North", areas: [{ id: "jimeta", name: "Jimeta" }, { id: "yola-main", name: "Yola" }] },
      { id: "yola-south", name: "Yola South", areas: [{ id: "yola-south", name: "Yola South" }] },
    ],
  },
  {
    id: "akwa-ibom",
    name: "Akwa Ibom State",
    capital: "Uyo",
    lgas: [
      { id: "abak", name: "Abak", areas: [{ id: "abak-main", name: "Abak" }] },
      { id: "eastern-obolo", name: "Eastern Obolo", areas: [{ id: "eastern-obolo-main", name: "Eastern Obolo" }] },
      { id: "eket", name: "Eket", areas: [{ id: "eket-main", name: "Eket" }] },
      { id: "esit-eket", name: "Esit Eket", areas: [{ id: "esit-eket-main", name: "Esit Eket" }] },
      { id: "essien-udim", name: "Essien Udim", areas: [{ id: "essien-udim-main", name: "Essien Udim" }] },
      { id: "etim-ekpo", name: "Etim Ekpo", areas: [{ id: "etim-ekpo-main", name: "Etim Ekpo" }] },
      { id: "etinan", name: "Etinan", areas: [{ id: "etinan-main", name: "Etinan" }] },
      { id: "ibeno", name: "Ibeno", areas: [{ id: "ibeno-main", name: "Ibeno" }] },
      { id: "ibesikpo-asutan", name: "Ibesikpo Asutan", areas: [{ id: "ibesikpo-main", name: "Ibesikpo" }] },
      { id: "ibiono-ibom", name: "Ibiono Ibom", areas: [{ id: "ibiono-main", name: "Ibiono" }] },
      { id: "ika", name: "Ika", areas: [{ id: "ika-main", name: "Ika" }] },
      { id: "ikono", name: "Ikono", areas: [{ id: "ikono-main", name: "Ikono" }] },
      { id: "ikot-abasi", name: "Ikot Abasi", areas: [{ id: "ikot-abasi-main", name: "Ikot Abasi" }] },
      { id: "ikot-ekpene", name: "Ikot Ekpene", areas: [{ id: "ikot-ekpene-main", name: "Ikot Ekpene" }] },
      { id: "ini", name: "Ini", areas: [{ id: "ini-main", name: "Ini" }] },
      { id: "itu", name: "Itu", areas: [{ id: "itu-main", name: "Itu" }] },
      { id: "mbo", name: "Mbo", areas: [{ id: "mbo-main", name: "Mbo" }] },
      { id: "mkpat-enin", name: "Mkpat Enin", areas: [{ id: "mkpat-main", name: "Mkpat Enin" }] },
      { id: "nsit-atai", name: "Nsit Atai", areas: [{ id: "nsit-atai-main", name: "Nsit Atai" }] },
      { id: "nsit-ibom", name: "Nsit Ibom", areas: [{ id: "nsit-ibom-main", name: "Nsit Ibom" }] },
      { id: "nsit-ubium", name: "Nsit Ubium", areas: [{ id: "nsit-ubium-main", name: "Nsit Ubium" }] },
      { id: "obot-akara", name: "Obot Akara", areas: [{ id: "obot-akara-main", name: "Obot Akara" }] },
      { id: "okobo", name: "Okobo", areas: [{ id: "okobo-main", name: "Okobo" }] },
      { id: "onna", name: "Onna", areas: [{ id: "onna-main", name: "Onna" }] },
      { id: "oron", name: "Oron", areas: [{ id: "oron-main", name: "Oron" }] },
      { id: "oruk-anam", name: "Oruk Anam", areas: [{ id: "oruk-anam-main", name: "Oruk Anam" }] },
      { id: "udung-uko", name: "Udung Uko", areas: [{ id: "udung-uko-main", name: "Udung Uko" }] },
      { id: "ukanafun", name: "Ukanafun", areas: [{ id: "ukanafun-main", name: "Ukanafun" }] },
      { id: "uruan", name: "Uruan", areas: [{ id: "uruan-main", name: "Uruan" }] },
      { id: "urue-offong-oruko", name: "Urue-Offong/Oruko", areas: [{ id: "urue-main", name: "Urue-Offong" }] },
      { id: "uyo", name: "Uyo", areas: [{ id: "uyo-main", name: "Uyo" }, { id: "use-offot", name: "Use Offot" }, { id: "ewet-housing", name: "Ewet Housing" }] },
    ],
  },
  {
    id: "anambra",
    name: "Anambra State",
    capital: "Awka",
    lgas: [
      { id: "aguata", name: "Aguata", areas: [{ id: "aguata-main", name: "Aguata" }] },
      { id: "anambra-east", name: "Anambra East", areas: [{ id: "anambra-east-main", name: "Anambra East" }] },
      { id: "anambra-west", name: "Anambra West", areas: [{ id: "anambra-west-main", name: "Anambra West" }] },
      { id: "anaocha", name: "Anaocha", areas: [{ id: "neni", name: "Neni" }] },
      { id: "awka-north", name: "Awka North", areas: [{ id: "awka-north-main", name: "Awka North" }] },
      { id: "awka-south", name: "Awka South", areas: [{ id: "awka-main", name: "Awka" }, { id: "amawbia", name: "Amawbia" }] },
      { id: "ayamelum", name: "Ayamelum", areas: [{ id: "ayamelum-main", name: "Ayamelum" }] },
      { id: "dunukofia", name: "Dunukofia", areas: [{ id: "dunukofia-main", name: "Dunukofia" }] },
      { id: "ekwusigo", name: "Ekwusigo", areas: [{ id: "ekwusigo-main", name: "Ekwusigo" }] },
      { id: "idemili-north", name: "Idemili North", areas: [{ id: "ogidi", name: "Ogidi" }, { id: "obosi", name: "Obosi" }] },
      { id: "idemili-south", name: "Idemili South", areas: [{ id: "oba", name: "Oba" }, { id: "ojoto", name: "Ojoto" }] },
      { id: "ihiala", name: "Ihiala", areas: [{ id: "ihiala-main", name: "Ihiala" }] },
      { id: "njikoka", name: "Njikoka", areas: [{ id: "abagana", name: "Abagana" }] },
      { id: "nnewi-north", name: "Nnewi North", areas: [{ id: "nnewi-main", name: "Nnewi" }] },
      { id: "nnewi-south", name: "Nnewi South", areas: [{ id: "nnewi-south-main", name: "Nnewi South" }] },
      { id: "ogbaru", name: "Ogbaru", areas: [{ id: "ogbaru-main", name: "Ogbaru" }] },
      { id: "onitsha-north", name: "Onitsha North", areas: [{ id: "onitsha-main", name: "Onitsha Main Market" }, { id: "fegge", name: "Fegge" }] },
      { id: "onitsha-south", name: "Onitsha South", areas: [{ id: "onitsha-south", name: "Onitsha South" }] },
      { id: "orumba-north", name: "Orumba North", areas: [{ id: "orumba-north-main", name: "Orumba North" }] },
      { id: "orumba-south", name: "Orumba South", areas: [{ id: "orumba-south-main", name: "Orumba South" }] },
      { id: "oyi", name: "Oyi", areas: [{ id: "oyi-main", name: "Oyi" }] },
    ],
  },
  {
    id: "bauchi",
    name: "Bauchi State",
    capital: "Bauchi",
    lgas: [
      { id: "alkaleri", name: "Alkaleri", areas: [{ id: "alkaleri-main", name: "Alkaleri" }] },
      { id: "bauchi", name: "Bauchi", areas: [{ id: "bauchi-main", name: "Bauchi" }, { id: "wunti", name: "Wunti" }] },
      { id: "bogoro", name: "Bogoro", areas: [{ id: "bogoro-main", name: "Bogoro" }] },
      { id: "damban", name: "Damban", areas: [{ id: "damban-main", name: "Damban" }] },
      { id: "darazo", name: "Darazo", areas: [{ id: "darazo-main", name: "Darazo" }] },
      { id: "dass", name: "Dass", areas: [{ id: "dass-main", name: "Dass" }] },
      { id: "gamawa", name: "Gamawa", areas: [{ id: "gamawa-main", name: "Gamawa" }] },
      { id: "ganjuwa", name: "Ganjuwa", areas: [{ id: "ganjuwa-main", name: "Ganjuwa" }] },
      { id: "giade", name: "Giade", areas: [{ id: "giade-main", name: "Giade" }] },
      { id: "itas-gadau", name: "Itas/Gadau", areas: [{ id: "itas-main", name: "Itas" }] },
      { id: "jamaare", name: "Jama'are", areas: [{ id: "jamaare-main", name: "Jama'are" }] },
      { id: "katagum", name: "Katagum", areas: [{ id: "azare", name: "Azare" }] },
      { id: "kirfi", name: "Kirfi", areas: [{ id: "kirfi-main", name: "Kirfi" }] },
      { id: "misau", name: "Misau", areas: [{ id: "misau-main", name: "Misau" }] },
      { id: "ningi", name: "Ningi", areas: [{ id: "ningi-main", name: "Ningi" }] },
      { id: "shira", name: "Shira", areas: [{ id: "shira-main", name: "Shira" }] },
      { id: "tafawa-balewa", name: "Tafawa Balewa", areas: [{ id: "tafawa-main", name: "Tafawa Balewa" }] },
      { id: "toro", name: "Toro", areas: [{ id: "toro-main", name: "Toro" }] },
      { id: "warji", name: "Warji", areas: [{ id: "warji-main", name: "Warji" }] },
      { id: "zaki", name: "Zaki", areas: [{ id: "zaki-main", name: "Zaki" }] },
    ],
  },
  {
    id: "bayelsa",
    name: "Bayelsa State",
    capital: "Yenagoa",
    lgas: [
      { id: "brass", name: "Brass", areas: [{ id: "brass-main", name: "Brass" }] },
      { id: "ekeremor", name: "Ekeremor", areas: [{ id: "ekeremor-main", name: "Ekeremor" }] },
      { id: "kolokuma-opokuma", name: "Kolokuma/Opokuma", areas: [{ id: "kolokuma-main", name: "Kolokuma" }] },
      { id: "nembe", name: "Nembe", areas: [{ id: "nembe-main", name: "Nembe" }] },
      { id: "ogbia", name: "Ogbia", areas: [{ id: "ogbia-main", name: "Ogbia" }] },
      { id: "sagbama", name: "Sagbama", areas: [{ id: "sagbama-main", name: "Sagbama" }] },
      { id: "southern-ijaw", name: "Southern Ijaw", areas: [{ id: "southern-ijaw-main", name: "Southern Ijaw" }] },
      { id: "yenagoa", name: "Yenagoa", areas: [{ id: "yenagoa-main", name: "Yenagoa" }, { id: "kpansia", name: "Kpansia" }, { id: "opolo", name: "Opolo" }] },
    ],
  },
  {
    id: "benue",
    name: "Benue State",
    capital: "Makurdi",
    lgas: [
      { id: "ado", name: "Ado", areas: [{ id: "ado-main", name: "Ado" }] },
      { id: "agatu", name: "Agatu", areas: [{ id: "agatu-main", name: "Agatu" }] },
      { id: "apa", name: "Apa", areas: [{ id: "apa-main", name: "Apa" }] },
      { id: "buruku", name: "Buruku", areas: [{ id: "buruku-main", name: "Buruku" }] },
      { id: "gboko", name: "Gboko", areas: [{ id: "gboko-main", name: "Gboko" }] },
      { id: "guma", name: "Guma", areas: [{ id: "guma-main", name: "Guma" }] },
      { id: "gwer-east", name: "Gwer East", areas: [{ id: "gwer-east-main", name: "Gwer East" }] },
      { id: "gwer-west", name: "Gwer West", areas: [{ id: "gwer-west-main", name: "Gwer West" }] },
      { id: "katsina-ala", name: "Katsina-Ala", areas: [{ id: "katsina-ala-main", name: "Katsina-Ala" }] },
      { id: "konshisha", name: "Konshisha", areas: [{ id: "konshisha-main", name: "Konshisha" }] },
      { id: "kwande", name: "Kwande", areas: [{ id: "kwande-main", name: "Kwande" }] },
      { id: "logo", name: "Logo", areas: [{ id: "logo-main", name: "Logo" }] },
      { id: "makurdi", name: "Makurdi", areas: [{ id: "makurdi-main", name: "Makurdi" }, { id: "high-level", name: "High Level" }, { id: "north-bank", name: "North Bank" }] },
      { id: "obi", name: "Obi", areas: [{ id: "obi-main", name: "Obi" }] },
      { id: "ogbadibo", name: "Ogbadibo", areas: [{ id: "ogbadibo-main", name: "Ogbadibo" }] },
      { id: "ohimini", name: "Ohimini", areas: [{ id: "ohimini-main", name: "Ohimini" }] },
      { id: "oju", name: "Oju", areas: [{ id: "oju-main", name: "Oju" }] },
      { id: "okpokwu", name: "Okpokwu", areas: [{ id: "okpokwu-main", name: "Okpokwu" }] },
      { id: "oturkpo", name: "Oturkpo", areas: [{ id: "oturkpo-main", name: "Oturkpo" }] },
      { id: "tarka", name: "Tarka", areas: [{ id: "tarka-main", name: "Tarka" }] },
      { id: "ukum", name: "Ukum", areas: [{ id: "ukum-main", name: "Ukum" }] },
      { id: "ushongo", name: "Ushongo", areas: [{ id: "ushongo-main", name: "Ushongo" }] },
      { id: "vandeikya", name: "Vandeikya", areas: [{ id: "vandeikya-main", name: "Vandeikya" }] },
    ],
  },
  {
    id: "borno",
    name: "Borno State",
    capital: "Maiduguri",
    lgas: [
      { id: "abadam", name: "Abadam", areas: [{ id: "abadam-main", name: "Abadam" }] },
      { id: "askira-uba", name: "Askira/Uba", areas: [{ id: "askira-main", name: "Askira" }] },
      { id: "bama", name: "Bama", areas: [{ id: "bama-main", name: "Bama" }] },
      { id: "bayo", name: "Bayo", areas: [{ id: "bayo-main", name: "Bayo" }] },
      { id: "biu", name: "Biu", areas: [{ id: "biu-main", name: "Biu" }] },
      { id: "chibok", name: "Chibok", areas: [{ id: "chibok-main", name: "Chibok" }] },
      { id: "damboa", name: "Damboa", areas: [{ id: "damboa-main", name: "Damboa" }] },
      { id: "dikwa", name: "Dikwa", areas: [{ id: "dikwa-main", name: "Dikwa" }] },
      { id: "gubio", name: "Gubio", areas: [{ id: "gubio-main", name: "Gubio" }] },
      { id: "guzamala", name: "Guzamala", areas: [{ id: "guzamala-main", name: "Guzamala" }] },
      { id: "gwoza", name: "Gwoza", areas: [{ id: "gwoza-main", name: "Gwoza" }] },
      { id: "hawul", name: "Hawul", areas: [{ id: "hawul-main", name: "Hawul" }] },
      { id: "jere", name: "Jere", areas: [{ id: "jere-main", name: "Jere" }] },
      { id: "kaga", name: "Kaga", areas: [{ id: "kaga-main", name: "Kaga" }] },
      { id: "kala-balge", name: "Kala/Balge", areas: [{ id: "kala-main", name: "Kala" }] },
      { id: "konduga", name: "Konduga", areas: [{ id: "konduga-main", name: "Konduga" }] },
      { id: "kukawa", name: "Kukawa", areas: [{ id: "kukawa-main", name: "Kukawa" }] },
      { id: "kwaya-kusar", name: "Kwaya Kusar", areas: [{ id: "kwaya-main", name: "Kwaya" }] },
      { id: "mafa", name: "Mafa", areas: [{ id: "mafa-main", name: "Mafa" }] },
      { id: "magumeri", name: "Magumeri", areas: [{ id: "magumeri-main", name: "Magumeri" }] },
      { id: "maiduguri", name: "Maiduguri", areas: [{ id: "maiduguri-main", name: "Maiduguri" }, { id: "bolori", name: "Bolori" }, { id: "gwange", name: "Gwange" }] },
      { id: "marte", name: "Marte", areas: [{ id: "marte-main", name: "Marte" }] },
      { id: "mobbar", name: "Mobbar", areas: [{ id: "mobbar-main", name: "Mobbar" }] },
      { id: "monguno", name: "Monguno", areas: [{ id: "monguno-main", name: "Monguno" }] },
      { id: "ngala", name: "Ngala", areas: [{ id: "ngala-main", name: "Ngala" }] },
      { id: "nganzai", name: "Nganzai", areas: [{ id: "nganzai-main", name: "Nganzai" }] },
      { id: "shani", name: "Shani", areas: [{ id: "shani-main", name: "Shani" }] },
    ],
  },
  {
    id: "cross-river",
    name: "Cross River State",
    capital: "Calabar",
    lgas: [
      { id: "abi", name: "Abi", areas: [{ id: "abi-main", name: "Abi" }] },
      { id: "akamkpa", name: "Akamkpa", areas: [{ id: "akamkpa-main", name: "Akamkpa" }] },
      { id: "akpabuyo", name: "Akpabuyo", areas: [{ id: "akpabuyo-main", name: "Akpabuyo" }] },
      { id: "bakassi", name: "Bakassi", areas: [{ id: "bakassi-main", name: "Bakassi" }] },
      { id: "bekwarra", name: "Bekwarra", areas: [{ id: "bekwarra-main", name: "Bekwarra" }] },
      { id: "biase", name: "Biase", areas: [{ id: "biase-main", name: "Biase" }] },
      { id: "boki", name: "Boki", areas: [{ id: "boki-main", name: "Boki" }] },
      { id: "calabar-municipal", name: "Calabar Municipal", areas: [{ id: "calabar-main", name: "Calabar" }, { id: "marian", name: "Marian" }, { id: "edim-otop", name: "Edim Otop" }] },
      { id: "calabar-south", name: "Calabar South", areas: [{ id: "calabar-south", name: "Calabar South" }] },
      { id: "etung", name: "Etung", areas: [{ id: "etung-main", name: "Etung" }] },
      { id: "ikom", name: "Ikom", areas: [{ id: "ikom-main", name: "Ikom" }] },
      { id: "obanliku", name: "Obanliku", areas: [{ id: "obanliku-main", name: "Obanliku" }] },
      { id: "obubra", name: "Obubra", areas: [{ id: "obubra-main", name: "Obubra" }] },
      { id: "obudu", name: "Obudu", areas: [{ id: "obudu-main", name: "Obudu" }] },
      { id: "odukpani", name: "Odukpani", areas: [{ id: "odukpani-main", name: "Odukpani" }] },
      { id: "ogoja", name: "Ogoja", areas: [{ id: "ogoja-main", name: "Ogoja" }] },
      { id: "yakurr", name: "Yakurr", areas: [{ id: "yakurr-main", name: "Yakurr" }] },
      { id: "yala", name: "Yala", areas: [{ id: "yala-main", name: "Yala" }] },
    ],
  },
  {
    id: "delta",
    name: "Delta State",
    capital: "Asaba",
    lgas: [
      { id: "aniocha-north", name: "Aniocha North", areas: [{ id: "aniocha-north-main", name: "Aniocha North" }] },
      { id: "aniocha-south", name: "Aniocha South", areas: [{ id: "ogwashi-uku", name: "Ogwashi-Uku" }] },
      { id: "bomadi", name: "Bomadi", areas: [{ id: "bomadi-main", name: "Bomadi" }] },
      { id: "burutu", name: "Burutu", areas: [{ id: "burutu-main", name: "Burutu" }] },
      { id: "ethiope-east", name: "Ethiope East", areas: [{ id: "isiokolo", name: "Isiokolo" }] },
      { id: "ethiope-west", name: "Ethiope West", areas: [{ id: "oghara", name: "Oghara" }] },
      { id: "ika-north-east", name: "Ika North East", areas: [{ id: "owa-oyibu", name: "Owa-Oyibu" }] },
      { id: "ika-south", name: "Ika South", areas: [{ id: "agbor", name: "Agbor" }] },
      { id: "isoko-north", name: "Isoko North", areas: [{ id: "ozoro", name: "Ozoro" }] },
      { id: "isoko-south", name: "Isoko South", areas: [{ id: "oleh", name: "Oleh" }] },
      { id: "ndokwa-east", name: "Ndokwa East", areas: [{ id: "aboh", name: "Aboh" }] },
      { id: "ndokwa-west", name: "Ndokwa West", areas: [{ id: "kwale", name: "Kwale" }] },
      { id: "okpe", name: "Okpe", areas: [{ id: "sapele", name: "Sapele" }] },
      { id: "oshimili-north", name: "Oshimili North", areas: [{ id: "akwukwu-igbo", name: "Akwukwu-Igbo" }] },
      { id: "oshimili-south", name: "Oshimili South", areas: [{ id: "asaba-main", name: "Asaba" }, { id: "okpanam", name: "Okpanam" }] },
      { id: "patani", name: "Patani", areas: [{ id: "patani-main", name: "Patani" }] },
      { id: "sapele", name: "Sapele", areas: [{ id: "sapele-main", name: "Sapele" }] },
      { id: "udu", name: "Udu", areas: [{ id: "ovwian", name: "Ovwian" }] },
      { id: "ughelli-north", name: "Ughelli North", areas: [{ id: "ughelli-main", name: "Ughelli" }] },
      { id: "ughelli-south", name: "Ughelli South", areas: [{ id: "otu-jeremi", name: "Otu-Jeremi" }] },
      { id: "ukwuani", name: "Ukwuani", areas: [{ id: "obiaruku", name: "Obiaruku" }] },
      { id: "uvwie", name: "Uvwie", areas: [{ id: "effurun", name: "Effurun" }] },
      { id: "warri-north", name: "Warri North", areas: [{ id: "koko", name: "Koko" }] },
      { id: "warri-south", name: "Warri South", areas: [{ id: "warri-main", name: "Warri" }] },
      { id: "warri-south-west", name: "Warri South West", areas: [{ id: "ogbe-ijoh", name: "Ogbe-Ijoh" }] },
    ],
  },
  {
    id: "ebonyi",
    name: "Ebonyi State",
    capital: "Abakaliki",
    lgas: [
      { id: "abakaliki", name: "Abakaliki", areas: [{ id: "abakaliki-main", name: "Abakaliki" }, { id: "kpirikpiri", name: "Kpirikpiri" }] },
      { id: "afikpo-north", name: "Afikpo North", areas: [{ id: "afikpo-main", name: "Afikpo" }] },
      { id: "afikpo-south", name: "Afikpo South", areas: [{ id: "afikpo-south-main", name: "Afikpo South" }] },
      { id: "ebonyi", name: "Ebonyi", areas: [{ id: "ebonyi-main", name: "Ebonyi" }] },
      { id: "ezza-north", name: "Ezza North", areas: [{ id: "ezza-north-main", name: "Ezza North" }] },
      { id: "ezza-south", name: "Ezza South", areas: [{ id: "ezza-south-main", name: "Ezza South" }] },
      { id: "ikwo", name: "Ikwo", areas: [{ id: "ikwo-main", name: "Ikwo" }] },
      { id: "ishielu", name: "Ishielu", areas: [{ id: "ishielu-main", name: "Ishielu" }] },
      { id: "ivo", name: "Ivo", areas: [{ id: "ivo-main", name: "Ivo" }] },
      { id: "izzi", name: "Izzi", areas: [{ id: "izzi-main", name: "Izzi" }] },
      { id: "ohaozara", name: "Ohaozara", areas: [{ id: "ohaozara-main", name: "Ohaozara" }] },
      { id: "ohaukwu", name: "Ohaukwu", areas: [{ id: "ohaukwu-main", name: "Ohaukwu" }] },
      { id: "onicha", name: "Onicha", areas: [{ id: "onicha-main", name: "Onicha" }] },
    ],
  },
  {
    id: "edo",
    name: "Edo State",
    capital: "Benin City",
    lgas: [
      { id: "akoko-edo", name: "Akoko-Edo", areas: [{ id: "igarra", name: "Igarra" }] },
      { id: "egor", name: "Egor", areas: [{ id: "uselu", name: "Uselu" }] },
      { id: "esan-central", name: "Esan Central", areas: [{ id: "irrua", name: "Irrua" }] },
      { id: "esan-north-east", name: "Esan North-East", areas: [{ id: "uromi", name: "Uromi" }] },
      { id: "esan-south-east", name: "Esan South-East", areas: [{ id: "ubiaja", name: "Ubiaja" }] },
      { id: "esan-west", name: "Esan West", areas: [{ id: "ekpoma", name: "Ekpoma" }] },
      { id: "etsako-central", name: "Etsako Central", areas: [{ id: "fugar", name: "Fugar" }] },
      { id: "etsako-east", name: "Etsako East", areas: [{ id: "agenebode", name: "Agenebode" }] },
      { id: "etsako-west", name: "Etsako West", areas: [{ id: "auchi", name: "Auchi" }] },
      { id: "igueben", name: "Igueben", areas: [{ id: "igueben-main", name: "Igueben" }] },
      { id: "ikpoba-okha", name: "Ikpoba-Okha", areas: [{ id: "idogbo", name: "Idogbo" }] },
      { id: "oredo", name: "Oredo", areas: [{ id: "benin-city", name: "Benin City" }, { id: "ring-road", name: "Ring Road" }, { id: "gra", name: "GRA" }] },
      { id: "orhionmwon", name: "Orhionmwon", areas: [{ id: "abudu", name: "Abudu" }] },
      { id: "ovia-north-east", name: "Ovia North-East", areas: [{ id: "okada", name: "Okada" }] },
      { id: "ovia-south-west", name: "Ovia South-West", areas: [{ id: "iguobazuwa", name: "Iguobazuwa" }] },
      { id: "owan-east", name: "Owan East", areas: [{ id: "afuze", name: "Afuze" }] },
      { id: "owan-west", name: "Owan West", areas: [{ id: "sabongida-ora", name: "Sabongida-Ora" }] },
      { id: "uhunmwonde", name: "Uhunmwonde", areas: [{ id: "ehor", name: "Ehor" }] },
    ],
  },
  {
    id: "ekiti",
    name: "Ekiti State",
    capital: "Ado-Ekiti",
    lgas: [
      { id: "ado-ekiti", name: "Ado Ekiti", areas: [{ id: "ado-ekiti-main", name: "Ado Ekiti" }, { id: "fajuyi", name: "Fajuyi" }, { id: "basiri", name: "Basiri" }] },
      { id: "efon", name: "Efon", areas: [{ id: "efon-main", name: "Efon-Alaaye" }] },
      { id: "ekiti-east", name: "Ekiti East", areas: [{ id: "omuo", name: "Omuo" }] },
      { id: "ekiti-south-west", name: "Ekiti South-West", areas: [{ id: "ilawe", name: "Ilawe-Ekiti" }] },
      { id: "ekiti-west", name: "Ekiti West", areas: [{ id: "aramoko", name: "Aramoko-Ekiti" }] },
      { id: "emure", name: "Emure", areas: [{ id: "emure-main", name: "Emure-Ekiti" }] },
      { id: "gbonyin", name: "Gbonyin", areas: [{ id: "ode", name: "Ode-Ekiti" }] },
      { id: "ido-osi", name: "Ido-Osi", areas: [{ id: "ido", name: "Ido-Ekiti" }] },
      { id: "ijero", name: "Ijero", areas: [{ id: "ijero-main", name: "Ijero-Ekiti" }] },
      { id: "ikere", name: "Ikere", areas: [{ id: "ikere-main", name: "Ikere-Ekiti" }] },
      { id: "ikole", name: "Ikole", areas: [{ id: "ikole-main", name: "Ikole-Ekiti" }] },
      { id: "ilejemeje", name: "Ilejemeje", areas: [{ id: "iye", name: "Iye-Ekiti" }] },
      { id: "irepodun-ifelodun", name: "Irepodun/Ifelodun", areas: [{ id: "igede", name: "Igede-Ekiti" }] },
      { id: "ise-orun", name: "Ise/Orun", areas: [{ id: "ise", name: "Ise-Ekiti" }] },
      { id: "moba", name: "Moba", areas: [{ id: "otun", name: "Otun-Ekiti" }] },
      { id: "oye", name: "Oye", areas: [{ id: "oye-main", name: "Oye-Ekiti" }] },
    ],
  },
  {
    id: "enugu",
    name: "Enugu State",
    capital: "Enugu",
    lgas: [
      { id: "aninri", name: "Aninri", areas: [{ id: "aninri-main", name: "Aninri" }] },
      { id: "awgu", name: "Awgu", areas: [{ id: "awgu-main", name: "Awgu" }] },
      { id: "enugu-east", name: "Enugu East", areas: [{ id: "nkwo-nike", name: "Nkwo Nike" }] },
      { id: "enugu-north", name: "Enugu North", areas: [{ id: "ogui", name: "Ogui" }, { id: "gra", name: "GRA" }] },
      { id: "enugu-south", name: "Enugu South", areas: [{ id: "achara-layout", name: "Achara Layout" }, { id: "uwani", name: "Uwani" }] },
      { id: "ezeagu", name: "Ezeagu", areas: [{ id: "ezeagu-main", name: "Ezeagu" }] },
      { id: "igbo-etiti", name: "Igbo-Etiti", areas: [{ id: "ogbede", name: "Ogbede" }] },
      { id: "igbo-eze-north", name: "Igbo-Eze North", areas: [{ id: "enugu-ezike", name: "Enugu-Ezike" }] },
      { id: "igbo-eze-south", name: "Igbo-Eze South", areas: [{ id: "ibagwa-aka", name: "Ibagwa-Aka" }] },
      { id: "isi-uzo", name: "Isi Uzo", areas: [{ id: "ikem", name: "Ikem" }] },
      { id: "nkanu-east", name: "Nkanu East", areas: [{ id: "amagunze", name: "Amagunze" }] },
      { id: "nkanu-west", name: "Nkanu West", areas: [{ id: "agbani", name: "Agbani" }] },
      { id: "nsukka", name: "Nsukka", areas: [{ id: "nsukka-main", name: "Nsukka" }, { id: "unn", name: "University of Nigeria" }] },
      { id: "oji-river", name: "Oji River", areas: [{ id: "oji-river-main", name: "Oji River" }] },
      { id: "udenu", name: "Udenu", areas: [{ id: "obollo-afor", name: "Obollo-Afor" }] },
      { id: "udi", name: "Udi", areas: [{ id: "udi-main", name: "Udi" }] },
      { id: "uzo-uwani", name: "Uzo-Uwani", areas: [{ id: "umulokpa", name: "Umulokpa" }] },
    ],
  },
  {
    id: "gombe",
    name: "Gombe State",
    capital: "Gombe",
    lgas: [
      { id: "akko", name: "Akko", areas: [{ id: "kumo", name: "Kumo" }] },
      { id: "balanga", name: "Balanga", areas: [{ id: "balanga-main", name: "Balanga" }] },
      { id: "billiri", name: "Billiri", areas: [{ id: "billiri-main", name: "Billiri" }] },
      { id: "dukku", name: "Dukku", areas: [{ id: "dukku-main", name: "Dukku" }] },
      { id: "funakaye", name: "Funakaye", areas: [{ id: "bajoga", name: "Bajoga" }] },
      { id: "gombe", name: "Gombe", areas: [{ id: "gombe-main", name: "Gombe" }, { id: "tudun-wada", name: "Tudun Wada" }] },
      { id: "kaltungo", name: "Kaltungo", areas: [{ id: "kaltungo-main", name: "Kaltungo" }] },
      { id: "kwami", name: "Kwami", areas: [{ id: "kwami-main", name: "Kwami" }] },
      { id: "nafada", name: "Nafada", areas: [{ id: "nafada-main", name: "Nafada" }] },
      { id: "shongom", name: "Shongom", areas: [{ id: "shongom-main", name: "Shongom" }] },
      { id: "yamaltu-deba", name: "Yamaltu/Deba", areas: [{ id: "deba", name: "Deba" }] },
    ],
  },
  {
    id: "imo",
    name: "Imo State",
    capital: "Owerri",
    lgas: [
      { id: "aboh-mbaise", name: "Aboh Mbaise", areas: [{ id: "aboh-mbaise-main", name: "Aboh Mbaise" }] },
      { id: "ahiazu-mbaise", name: "Ahiazu Mbaise", areas: [{ id: "ahiazu-mbaise-main", name: "Ahiazu Mbaise" }] },
      { id: "ehime-mbano", name: "Ehime Mbano", areas: [{ id: "ehime-mbano-main", name: "Ehime Mbano" }] },
      { id: "ezinihitte", name: "Ezinihitte", areas: [{ id: "ezinihitte-main", name: "Ezinihitte" }] },
      { id: "ideato-north", name: "Ideato North", areas: [{ id: "urualla", name: "Urualla" }] },
      { id: "ideato-south", name: "Ideato South", areas: [{ id: "dikenafai", name: "Dikenafai" }] },
      { id: "ihitte-uboma", name: "Ihitte/Uboma", areas: [{ id: "ihitte-main", name: "Ihitte" }] },
      { id: "ikeduru", name: "Ikeduru", areas: [{ id: "ikeduru-main", name: "Ikeduru" }] },
      { id: "isiala-mbano", name: "Isiala Mbano", areas: [{ id: "isiala-mbano-main", name: "Isiala Mbano" }] },
      { id: "isu", name: "Isu", areas: [{ id: "isu-main", name: "Isu" }] },
      { id: "mbaitoli", name: "Mbaitoli", areas: [{ id: "mbaitoli-main", name: "Mbaitoli" }] },
      { id: "ngor-okpala", name: "Ngor Okpala", areas: [{ id: "ngor-okpala-main", name: "Ngor Okpala" }] },
      { id: "njaba", name: "Njaba", areas: [{ id: "njaba-main", name: "Njaba" }] },
      { id: "nkwerre", name: "Nkwerre", areas: [{ id: "nkwerre-main", name: "Nkwerre" }] },
      { id: "nwangele", name: "Nwangele", areas: [{ id: "nwangele-main", name: "Nwangele" }] },
      { id: "obowo", name: "Obowo", areas: [{ id: "obowo-main", name: "Obowo" }] },
      { id: "oguta", name: "Oguta", areas: [{ id: "oguta-main", name: "Oguta" }] },
      { id: "ohaji-egbema", name: "Ohaji/Egbema", areas: [{ id: "ohaji-main", name: "Ohaji" }] },
      { id: "okigwe", name: "Okigwe", areas: [{ id: "okigwe-main", name: "Okigwe" }] },
      { id: "orlu", name: "Orlu", areas: [{ id: "orlu-main", name: "Orlu" }] },
      { id: "orsu", name: "Orsu", areas: [{ id: "orsu-main", name: "Orsu" }] },
      { id: "oru-east", name: "Oru East", areas: [{ id: "oru-east-main", name: "Oru East" }] },
      { id: "oru-west", name: "Oru West", areas: [{ id: "mgbidi", name: "Mgbidi" }] },
      { id: "owerri-municipal", name: "Owerri Municipal", areas: [{ id: "owerri-main", name: "Owerri" }, { id: "douglas-road", name: "Douglas Road" }, { id: "new-owerri", name: "New Owerri" }] },
      { id: "owerri-north", name: "Owerri North", areas: [{ id: "owerri-north-main", name: "Owerri North" }] },
      { id: "owerri-west", name: "Owerri West", areas: [{ id: "owerri-west-main", name: "Owerri West" }] },
      { id: "unuimo", name: "Unuimo", areas: [{ id: "unuimo-main", name: "Unuimo" }] },
    ],
  },
  {
    id: "jigawa",
    name: "Jigawa State",
    capital: "Dutse",
    lgas: [
      { id: "auyo", name: "Auyo", areas: [{ id: "auyo-main", name: "Auyo" }] },
      { id: "babura", name: "Babura", areas: [{ id: "babura-main", name: "Babura" }] },
      { id: "birniwa", name: "Birniwa", areas: [{ id: "birniwa-main", name: "Birniwa" }] },
      { id: "birnin-kudu", name: "Birnin Kudu", areas: [{ id: "birnin-kudu-main", name: "Birnin Kudu" }] },
      { id: "buji", name: "Buji", areas: [{ id: "buji-main", name: "Buji" }] },
      { id: "dutse", name: "Dutse", areas: [{ id: "dutse-main", name: "Dutse" }] },
      { id: "gagarawa", name: "Gagarawa", areas: [{ id: "gagarawa-main", name: "Gagarawa" }] },
      { id: "garki", name: "Garki", areas: [{ id: "garki-main", name: "Garki" }] },
      { id: "gumel", name: "Gumel", areas: [{ id: "gumel-main", name: "Gumel" }] },
      { id: "guri", name: "Guri", areas: [{ id: "guri-main", name: "Guri" }] },
      { id: "gwaram", name: "Gwaram", areas: [{ id: "gwaram-main", name: "Gwaram" }] },
      { id: "gwiwa", name: "Gwiwa", areas: [{ id: "gwiwa-main", name: "Gwiwa" }] },
      { id: "hadejia", name: "Hadejia", areas: [{ id: "hadejia-main", name: "Hadejia" }] },
      { id: "jahun", name: "Jahun", areas: [{ id: "jahun-main", name: "Jahun" }] },
      { id: "kafin-hausa", name: "Kafin Hausa", areas: [{ id: "kafin-hausa-main", name: "Kafin Hausa" }] },
      { id: "kaugama", name: "Kaugama", areas: [{ id: "kaugama-main", name: "Kaugama" }] },
      { id: "kazaure", name: "Kazaure", areas: [{ id: "kazaure-main", name: "Kazaure" }] },
      { id: "kiri-kasamma", name: "Kiri Kasamma", areas: [{ id: "kiri-main", name: "Kiri" }] },
      { id: "kiyawa", name: "Kiyawa", areas: [{ id: "kiyawa-main", name: "Kiyawa" }] },
      { id: "maigatari", name: "Maigatari", areas: [{ id: "maigatari-main", name: "Maigatari" }] },
      { id: "malam-madori", name: "Malam Madori", areas: [{ id: "malam-madori-main", name: "Malam Madori" }] },
      { id: "miga", name: "Miga", areas: [{ id: "miga-main", name: "Miga" }] },
      { id: "ringim", name: "Ringim", areas: [{ id: "ringim-main", name: "Ringim" }] },
      { id: "roni", name: "Roni", areas: [{ id: "roni-main", name: "Roni" }] },
      { id: "sule-tankarkar", name: "Sule Tankarkar", areas: [{ id: "sule-main", name: "Sule Tankarkar" }] },
      { id: "taura", name: "Taura", areas: [{ id: "taura-main", name: "Taura" }] },
      { id: "yankwashi", name: "Yankwashi", areas: [{ id: "yankwashi-main", name: "Yankwashi" }] },
    ],
  },
  {
    id: "kaduna",
    name: "Kaduna State",
    capital: "Kaduna",
    lgas: [
      { id: "birnin-gwari", name: "Birnin Gwari", areas: [{ id: "birnin-gwari-main", name: "Birnin Gwari" }] },
      { id: "chikun", name: "Chikun", areas: [{ id: "chikun-main", name: "Chikun" }] },
      { id: "giwa", name: "Giwa", areas: [{ id: "giwa-main", name: "Giwa" }] },
      { id: "igabi", name: "Igabi", areas: [{ id: "igabi-main", name: "Igabi" }] },
      { id: "ikara", name: "Ikara", areas: [{ id: "ikara-main", name: "Ikara" }] },
      { id: "jaba", name: "Jaba", areas: [{ id: "jaba-main", name: "Jaba" }] },
      { id: "jema-a", name: "Jema'a", areas: [{ id: "kafanchan", name: "Kafanchan" }] },
      { id: "kachia", name: "Kachia", areas: [{ id: "kachia-main", name: "Kachia" }] },
      { id: "kaduna-north", name: "Kaduna North", areas: [{ id: "kaduna-north-main", name: "Kaduna North" }, { id: "malali", name: "Malali" }] },
      { id: "kaduna-south", name: "Kaduna South", areas: [{ id: "kaduna-south-main", name: "Kaduna South" }, { id: "barnawa", name: "Barnawa" }] },
      { id: "kagarko", name: "Kagarko", areas: [{ id: "kagarko-main", name: "Kagarko" }] },
      { id: "kajuru", name: "Kajuru", areas: [{ id: "kajuru-main", name: "Kajuru" }] },
      { id: "kaura", name: "Kaura", areas: [{ id: "kaura-main", name: "Kaura" }] },
      { id: "kauru", name: "Kauru", areas: [{ id: "kauru-main", name: "Kauru" }] },
      { id: "kubau", name: "Kubau", areas: [{ id: "kubau-main", name: "Kubau" }] },
      { id: "kudan", name: "Kudan", areas: [{ id: "kudan-main", name: "Kudan" }] },
      { id: "lere", name: "Lere", areas: [{ id: "lere-main", name: "Lere" }] },
      { id: "makarfi", name: "Makarfi", areas: [{ id: "makarfi-main", name: "Makarfi" }] },
      { id: "sabon-gari", name: "Sabon Gari", areas: [{ id: "sabon-gari-main", name: "Sabon Gari" }] },
      { id: "sanga", name: "Sanga", areas: [{ id: "sanga-main", name: "Sanga" }] },
      { id: "soba", name: "Soba", areas: [{ id: "soba-main", name: "Soba" }] },
      { id: "zangon-kataf", name: "Zangon Kataf", areas: [{ id: "zonkwa", name: "Zonkwa" }] },
      { id: "zaria", name: "Zaria", areas: [{ id: "zaria-main", name: "Zaria" }, { id: "tudun-wada-zaria", name: "Tudun Wada" }] },
    ],
  },
  {
    id: "kano",
    name: "Kano State",
    capital: "Kano",
    lgas: [
      { id: "ajingi", name: "Ajingi", areas: [{ id: "ajingi-main", name: "Ajingi" }] },
      { id: "albasu", name: "Albasu", areas: [{ id: "albasu-main", name: "Albasu" }] },
      { id: "bagwai", name: "Bagwai", areas: [{ id: "bagwai-main", name: "Bagwai" }] },
      { id: "bebeji", name: "Bebeji", areas: [{ id: "bebeji-main", name: "Bebeji" }] },
      { id: "bichi", name: "Bichi", areas: [{ id: "bichi-main", name: "Bichi" }] },
      { id: "bunkure", name: "Bunkure", areas: [{ id: "bunkure-main", name: "Bunkure" }] },
      { id: "dala", name: "Dala", areas: [{ id: "dala-main", name: "Dala" }] },
      { id: "dambatta", name: "Dambatta", areas: [{ id: "dambatta-main", name: "Dambatta" }] },
      { id: "dawakin-kudu", name: "Dawakin Kudu", areas: [{ id: "dawakin-kudu-main", name: "Dawakin Kudu" }] },
      { id: "dawakin-tofa", name: "Dawakin Tofa", areas: [{ id: "dawakin-tofa-main", name: "Dawakin Tofa" }] },
      { id: "doguwa", name: "Doguwa", areas: [{ id: "doguwa-main", name: "Doguwa" }] },
      { id: "fagge", name: "Fagge", areas: [{ id: "fagge-main", name: "Fagge" }] },
      { id: "gabasawa", name: "Gabasawa", areas: [{ id: "gabasawa-main", name: "Gabasawa" }] },
      { id: "garko", name: "Garko", areas: [{ id: "garko-main", name: "Garko" }] },
      { id: "garun-mallam", name: "Garun Mallam", areas: [{ id: "garun-mallam-main", name: "Garun Mallam" }] },
      { id: "gaya", name: "Gaya", areas: [{ id: "gaya-main", name: "Gaya" }] },
      { id: "gezawa", name: "Gezawa", areas: [{ id: "gezawa-main", name: "Gezawa" }] },
      { id: "gwale", name: "Gwale", areas: [{ id: "gwale-main", name: "Gwale" }] },
      { id: "gwarzo", name: "Gwarzo", areas: [{ id: "gwarzo-main", name: "Gwarzo" }] },
      { id: "kabo", name: "Kabo", areas: [{ id: "kabo-main", name: "Kabo" }] },
      { id: "kano-municipal", name: "Kano Municipal", areas: [{ id: "kano-main", name: "Kano" }, { id: "sabon-gari-kano", name: "Sabon Gari" }, { id: "bompai", name: "Bompai" }] },
      { id: "karaye", name: "Karaye", areas: [{ id: "karaye-main", name: "Karaye" }] },
      { id: "kibiya", name: "Kibiya", areas: [{ id: "kibiya-main", name: "Kibiya" }] },
      { id: "kiru", name: "Kiru", areas: [{ id: "kiru-main", name: "Kiru" }] },
      { id: "kumbotso", name: "Kumbotso", areas: [{ id: "kumbotso-main", name: "Kumbotso" }] },
      { id: "kunchi", name: "Kunchi", areas: [{ id: "kunchi-main", name: "Kunchi" }] },
      { id: "kura", name: "Kura", areas: [{ id: "kura-main", name: "Kura" }] },
      { id: "madobi", name: "Madobi", areas: [{ id: "madobi-main", name: "Madobi" }] },
      { id: "makoda", name: "Makoda", areas: [{ id: "makoda-main", name: "Makoda" }] },
      { id: "minjibir", name: "Minjibir", areas: [{ id: "minjibir-main", name: "Minjibir" }] },
      { id: "nasarawa-kano", name: "Nasarawa", areas: [{ id: "nasarawa-kano-main", name: "Nasarawa" }] },
      { id: "rano", name: "Rano", areas: [{ id: "rano-main", name: "Rano" }] },
      { id: "rimin-gado", name: "Rimin Gado", areas: [{ id: "rimin-gado-main", name: "Rimin Gado" }] },
      { id: "rogo", name: "Rogo", areas: [{ id: "rogo-main", name: "Rogo" }] },
      { id: "shanono", name: "Shanono", areas: [{ id: "shanono-main", name: "Shanono" }] },
      { id: "sumaila", name: "Sumaila", areas: [{ id: "sumaila-main", name: "Sumaila" }] },
      { id: "takai", name: "Takai", areas: [{ id: "takai-main", name: "Takai" }] },
      { id: "tarauni", name: "Tarauni", areas: [{ id: "tarauni-main", name: "Tarauni" }] },
      { id: "tofa", name: "Tofa", areas: [{ id: "tofa-main", name: "Tofa" }] },
      { id: "tsanyawa", name: "Tsanyawa", areas: [{ id: "tsanyawa-main", name: "Tsanyawa" }] },
      { id: "tudun-wada-kano", name: "Tudun Wada", areas: [{ id: "tudun-wada-kano-main", name: "Tudun Wada" }] },
      { id: "ungogo", name: "Ungogo", areas: [{ id: "ungogo-main", name: "Ungogo" }] },
      { id: "warawa", name: "Warawa", areas: [{ id: "warawa-main", name: "Warawa" }] },
      { id: "wudil", name: "Wudil", areas: [{ id: "wudil-main", name: "Wudil" }] },
    ],
  },
  {
    id: "katsina",
    name: "Katsina State",
    capital: "Katsina",
    lgas: [
      { id: "bakori", name: "Bakori", areas: [{ id: "bakori-main", name: "Bakori" }] },
      { id: "batagarawa", name: "Batagarawa", areas: [{ id: "batagarawa-main", name: "Batagarawa" }] },
      { id: "batsari", name: "Batsari", areas: [{ id: "batsari-main", name: "Batsari" }] },
      { id: "baure", name: "Baure", areas: [{ id: "baure-main", name: "Baure" }] },
      { id: "bindawa", name: "Bindawa", areas: [{ id: "bindawa-main", name: "Bindawa" }] },
      { id: "charanchi", name: "Charanchi", areas: [{ id: "charanchi-main", name: "Charanchi" }] },
      { id: "dandume", name: "Dandume", areas: [{ id: "dandume-main", name: "Dandume" }] },
      { id: "danja", name: "Danja", areas: [{ id: "danja-main", name: "Danja" }] },
      { id: "dan-musa", name: "Dan Musa", areas: [{ id: "dan-musa-main", name: "Dan Musa" }] },
      { id: "daura", name: "Daura", areas: [{ id: "daura-main", name: "Daura" }] },
      { id: "dutsi", name: "Dutsi", areas: [{ id: "dutsi-main", name: "Dutsi" }] },
      { id: "dutsin-ma", name: "Dutsin Ma", areas: [{ id: "dutsin-ma-main", name: "Dutsin Ma" }] },
      { id: "faskari", name: "Faskari", areas: [{ id: "faskari-main", name: "Faskari" }] },
      { id: "funtua", name: "Funtua", areas: [{ id: "funtua-main", name: "Funtua" }] },
      { id: "ingawa", name: "Ingawa", areas: [{ id: "ingawa-main", name: "Ingawa" }] },
      { id: "jibia", name: "Jibia", areas: [{ id: "jibia-main", name: "Jibia" }] },
      { id: "kafur", name: "Kafur", areas: [{ id: "kafur-main", name: "Kafur" }] },
      { id: "kaita", name: "Kaita", areas: [{ id: "kaita-main", name: "Kaita" }] },
      { id: "kankara", name: "Kankara", areas: [{ id: "kankara-main", name: "Kankara" }] },
      { id: "kankia", name: "Kankia", areas: [{ id: "kankia-main", name: "Kankia" }] },
      { id: "katsina", name: "Katsina", areas: [{ id: "katsina-main", name: "Katsina" }] },
      { id: "kurfi", name: "Kurfi", areas: [{ id: "kurfi-main", name: "Kurfi" }] },
      { id: "kusada", name: "Kusada", areas: [{ id: "kusada-main", name: "Kusada" }] },
      { id: "mai-adua", name: "Mai'Adua", areas: [{ id: "mai-adua-main", name: "Mai'Adua" }] },
      { id: "malumfashi", name: "Malumfashi", areas: [{ id: "malumfashi-main", name: "Malumfashi" }] },
      { id: "mani", name: "Mani", areas: [{ id: "mani-main", name: "Mani" }] },
      { id: "mashi", name: "Mashi", areas: [{ id: "mashi-main", name: "Mashi" }] },
      { id: "matazu", name: "Matazu", areas: [{ id: "matazu-main", name: "Matazu" }] },
      { id: "musawa", name: "Musawa", areas: [{ id: "musawa-main", name: "Musawa" }] },
      { id: "rimi", name: "Rimi", areas: [{ id: "rimi-main", name: "Rimi" }] },
      { id: "sabuwa", name: "Sabuwa", areas: [{ id: "sabuwa-main", name: "Sabuwa" }] },
      { id: "safana", name: "Safana", areas: [{ id: "safana-main", name: "Safana" }] },
      { id: "sandamu", name: "Sandamu", areas: [{ id: "sandamu-main", name: "Sandamu" }] },
      { id: "zango", name: "Zango", areas: [{ id: "zango-main", name: "Zango" }] },
    ],
  },
  {
    id: "kebbi",
    name: "Kebbi State",
    capital: "Birnin Kebbi",
    lgas: [
      { id: "aleiro", name: "Aleiro", areas: [{ id: "aleiro-main", name: "Aleiro" }] },
      { id: "arewa-dandi", name: "Arewa Dandi", areas: [{ id: "arewa-main", name: "Arewa" }] },
      { id: "argungu", name: "Argungu", areas: [{ id: "argungu-main", name: "Argungu" }] },
      { id: "augie", name: "Augie", areas: [{ id: "augie-main", name: "Augie" }] },
      { id: "bagudo", name: "Bagudo", areas: [{ id: "bagudo-main", name: "Bagudo" }] },
      { id: "birnin-kebbi", name: "Birnin Kebbi", areas: [{ id: "birnin-kebbi-main", name: "Birnin Kebbi" }] },
      { id: "bunza", name: "Bunza", areas: [{ id: "bunza-main", name: "Bunza" }] },
      { id: "dandi", name: "Dandi", areas: [{ id: "dandi-main", name: "Dandi" }] },
      { id: "fakai", name: "Fakai", areas: [{ id: "fakai-main", name: "Fakai" }] },
      { id: "gwandu", name: "Gwandu", areas: [{ id: "gwandu-main", name: "Gwandu" }] },
      { id: "jega", name: "Jega", areas: [{ id: "jega-main", name: "Jega" }] },
      { id: "kalgo", name: "Kalgo", areas: [{ id: "kalgo-main", name: "Kalgo" }] },
      { id: "koko-besse", name: "Koko/Besse", areas: [{ id: "koko-main", name: "Koko" }] },
      { id: "maiyama", name: "Maiyama", areas: [{ id: "maiyama-main", name: "Maiyama" }] },
      { id: "ngaski", name: "Ngaski", areas: [{ id: "ngaski-main", name: "Ngaski" }] },
      { id: "sakaba", name: "Sakaba", areas: [{ id: "sakaba-main", name: "Sakaba" }] },
      { id: "shanga", name: "Shanga", areas: [{ id: "shanga-main", name: "Shanga" }] },
      { id: "suru", name: "Suru", areas: [{ id: "suru-main", name: "Suru" }] },
      { id: "wasagu-danko", name: "Wasagu/Danko", areas: [{ id: "wasagu-main", name: "Wasagu" }] },
      { id: "yauri", name: "Yauri", areas: [{ id: "yauri-main", name: "Yauri" }] },
      { id: "zuru", name: "Zuru", areas: [{ id: "zuru-main", name: "Zuru" }] },
    ],
  },
  {
    id: "kogi",
    name: "Kogi State",
    capital: "Lokoja",
    lgas: [
      { id: "adavi", name: "Adavi", areas: [{ id: "adavi-main", name: "Adavi" }] },
      { id: "ajaokuta", name: "Ajaokuta", areas: [{ id: "ajaokuta-main", name: "Ajaokuta" }] },
      { id: "ankpa", name: "Ankpa", areas: [{ id: "ankpa-main", name: "Ankpa" }] },
      { id: "bassa", name: "Bassa", areas: [{ id: "bassa-main", name: "Bassa" }] },
      { id: "dekina", name: "Dekina", areas: [{ id: "dekina-main", name: "Dekina" }] },
      { id: "ibaji", name: "Ibaji", areas: [{ id: "ibaji-main", name: "Ibaji" }] },
      { id: "idah", name: "Idah", areas: [{ id: "idah-main", name: "Idah" }] },
      { id: "igalamela-odolu", name: "Igalamela-Odolu", areas: [{ id: "igalamela-main", name: "Igalamela" }] },
      { id: "ijumu", name: "Ijumu", areas: [{ id: "ijumu-main", name: "Ijumu" }] },
      { id: "kabba-bunu", name: "Kabba/Bunu", areas: [{ id: "kabba-main", name: "Kabba" }] },
      { id: "kogi", name: "Kogi", areas: [{ id: "kogi-main", name: "Kogi" }] },
      { id: "lokoja", name: "Lokoja", areas: [{ id: "lokoja-main", name: "Lokoja" }] },
      { id: "mopa-muro", name: "Mopa Muro", areas: [{ id: "mopa-main", name: "Mopa" }] },
      { id: "ofu", name: "Ofu", areas: [{ id: "ofu-main", name: "Ofu" }] },
      { id: "ogori-magongo", name: "Ogori/Magongo", areas: [{ id: "ogori-main", name: "Ogori" }] },
      { id: "okehi", name: "Okehi", areas: [{ id: "okehi-main", name: "Okehi" }] },
      { id: "okene", name: "Okene", areas: [{ id: "okene-main", name: "Okene" }] },
      { id: "olamaboro", name: "Olamaboro", areas: [{ id: "olamaboro-main", name: "Olamaboro" }] },
      { id: "omala", name: "Omala", areas: [{ id: "omala-main", name: "Omala" }] },
      { id: "yagba-east", name: "Yagba East", areas: [{ id: "yagba-east-main", name: "Yagba East" }] },
      { id: "yagba-west", name: "Yagba West", areas: [{ id: "yagba-west-main", name: "Yagba West" }] },
    ],
  },
  {
    id: "kwara",
    name: "Kwara State",
    capital: "Ilorin",
    lgas: [
      { id: "asa", name: "Asa", areas: [{ id: "asa-main", name: "Asa" }] },
      { id: "baruten", name: "Baruten", areas: [{ id: "baruten-main", name: "Baruten" }] },
      { id: "edu", name: "Edu", areas: [{ id: "lafiagi", name: "Lafiagi" }] },
      { id: "ekiti-kwara", name: "Ekiti", areas: [{ id: "ekiti-kwara-main", name: "Ekiti" }] },
      { id: "ifelodun", name: "Ifelodun", areas: [{ id: "share", name: "Share" }] },
      { id: "ilorin-east", name: "Ilorin East", areas: [{ id: "ilorin-east-main", name: "Ilorin East" }] },
      { id: "ilorin-south", name: "Ilorin South", areas: [{ id: "fufu", name: "Fufu" }] },
      { id: "ilorin-west", name: "Ilorin West", areas: [{ id: "ilorin-main", name: "Ilorin" }, { id: "gra-ilorin", name: "GRA" }] },
      { id: "irepodun-kwara", name: "Irepodun", areas: [{ id: "omu-aran", name: "Omu-Aran" }] },
      { id: "isin", name: "Isin", areas: [{ id: "owu-isin", name: "Owu-Isin" }] },
      { id: "kaiama", name: "Kaiama", areas: [{ id: "kaiama-main", name: "Kaiama" }] },
      { id: "moro", name: "Moro", areas: [{ id: "bode-saadu", name: "Bode Saadu" }] },
      { id: "offa", name: "Offa", areas: [{ id: "offa-main", name: "Offa" }] },
      { id: "oke-ero", name: "Oke Ero", areas: [{ id: "iloffa", name: "Iloffa" }] },
      { id: "oyun", name: "Oyun", areas: [{ id: "ilemona", name: "Ilemona" }] },
      { id: "pategi", name: "Pategi", areas: [{ id: "pategi-main", name: "Pategi" }] },
    ],
  },
  {
    id: "lagos",
    name: "Lagos State",
    capital: "Ikeja",
    lgas: [
      { id: "agege", name: "Agege", areas: [{ id: "agege-main", name: "Agege" }, { id: "ogba", name: "Ogba" }, { id: "pen-cinema", name: "Pen Cinema" }] },
      { id: "ajeromi-ifelodun", name: "Ajeromi-Ifelodun", areas: [{ id: "ajegunle", name: "Ajegunle" }] },
      { id: "alimosho", name: "Alimosho", areas: [{ id: "ikotun", name: "Ikotun" }, { id: "egbeda", name: "Egbeda" }, { id: "idimu", name: "Idimu" }, { id: "ipaja", name: "Ipaja" }, { id: "ayobo", name: "Ayobo" }] },
      { id: "amuwo-odofin", name: "Amuwo-Odofin", areas: [{ id: "festac", name: "Festac Town" }, { id: "mile-2", name: "Mile 2" }] },
      { id: "apapa", name: "Apapa", areas: [{ id: "apapa-main", name: "Apapa" }, { id: "ajegunle-apapa", name: "Ajegunle" }] },
      { id: "badagry", name: "Badagry", areas: [{ id: "badagry-main", name: "Badagry" }] },
      { id: "epe", name: "Epe", areas: [{ id: "epe-main", name: "Epe" }] },
      { id: "eti-osa", name: "Eti-Osa", areas: [{ id: "lekki", name: "Lekki Phase 1" }, { id: "lekki-2", name: "Lekki Phase 2" }, { id: "victoria-island", name: "Victoria Island" }, { id: "ikoyi", name: "Ikoyi" }, { id: "ajah", name: "Ajah" }, { id: "sangotedo", name: "Sangotedo" }] },
      { id: "ibeju-lekki", name: "Ibeju-Lekki", areas: [{ id: "ibeju", name: "Ibeju" }, { id: "lakowe", name: "Lakowe" }, { id: "eleko", name: "Eleko" }] },
      { id: "ifako-ijaiye", name: "Ifako-Ijaiye", areas: [{ id: "ifako", name: "Ifako" }, { id: "iju", name: "Iju" }] },
      { id: "ikeja", name: "Ikeja", areas: [{ id: "ikeja-gra", name: "Ikeja GRA" }, { id: "allen", name: "Allen Avenue" }, { id: "opebi", name: "Opebi" }, { id: "adeniyi-jones", name: "Adeniyi Jones" }, { id: "alausa", name: "Alausa" }, { id: "maryland", name: "Maryland" }, { id: "oregun", name: "Oregun" }] },
      { id: "ikorodu", name: "Ikorodu", areas: [{ id: "ikorodu-main", name: "Ikorodu" }, { id: "igbogbo", name: "Igbogbo" }] },
      { id: "kosofe", name: "Kosofe", areas: [{ id: "ketu", name: "Ketu" }, { id: "ojota", name: "Ojota" }, { id: "ogudu", name: "Ogudu" }, { id: "mile-12", name: "Mile 12" }] },
      { id: "lagos-island", name: "Lagos Island", areas: [{ id: "lagos-island-main", name: "Lagos Island" }, { id: "marina", name: "Marina" }, { id: "obalende", name: "Obalende" }] },
      { id: "lagos-mainland", name: "Lagos Mainland", areas: [{ id: "yaba", name: "Yaba" }, { id: "ebute-metta", name: "Ebute Metta" }, { id: "oyingbo", name: "Oyingbo" }, { id: "onike", name: "Onike" }] },
      { id: "mushin", name: "Mushin", areas: [{ id: "mushin-main", name: "Mushin" }, { id: "isolo", name: "Isolo" }] },
      { id: "ojo", name: "Ojo", areas: [{ id: "ojo-main", name: "Ojo" }, { id: "alaba", name: "Alaba" }] },
      { id: "oshodi-isolo", name: "Oshodi-Isolo", areas: [{ id: "oshodi", name: "Oshodi" }, { id: "isolo-area", name: "Isolo" }, { id: "ajao-estate", name: "Ajao Estate" }] },
      { id: "somolu", name: "Somolu", areas: [{ id: "somolu-main", name: "Somolu" }, { id: "gbagada", name: "Gbagada" }, { id: "bariga", name: "Bariga" }, { id: "anthony", name: "Anthony" }] },
      { id: "surulere", name: "Surulere", areas: [{ id: "surulere-main", name: "Surulere" }, { id: "ojuelegba", name: "Ojuelegba" }, { id: "aguda", name: "Aguda" }, { id: "iponri", name: "Iponri" }, { id: "bode-thomas", name: "Bode Thomas" }] },
    ],
  },
  {
    id: "nasarawa",
    name: "Nasarawa State",
    capital: "Lafia",
    lgas: [
      { id: "akwanga", name: "Akwanga", areas: [{ id: "akwanga-main", name: "Akwanga" }] },
      { id: "awe", name: "Awe", areas: [{ id: "awe-main", name: "Awe" }] },
      { id: "doma", name: "Doma", areas: [{ id: "doma-main", name: "Doma" }] },
      { id: "karu", name: "Karu", areas: [{ id: "karu-main", name: "Karu" }, { id: "mararaba", name: "Mararaba" }, { id: "masaka", name: "Masaka" }] },
      { id: "keana", name: "Keana", areas: [{ id: "keana-main", name: "Keana" }] },
      { id: "keffi", name: "Keffi", areas: [{ id: "keffi-main", name: "Keffi" }] },
      { id: "kokona", name: "Kokona", areas: [{ id: "kokona-main", name: "Kokona" }] },
      { id: "lafia", name: "Lafia", areas: [{ id: "lafia-main", name: "Lafia" }] },
      { id: "nasarawa", name: "Nasarawa", areas: [{ id: "nasarawa-main", name: "Nasarawa" }] },
      { id: "nasarawa-eggon", name: "Nasarawa Eggon", areas: [{ id: "nasarawa-eggon-main", name: "Nasarawa Eggon" }] },
      { id: "obi-nasarawa", name: "Obi", areas: [{ id: "obi-nasarawa-main", name: "Obi" }] },
      { id: "toto", name: "Toto", areas: [{ id: "toto-main", name: "Toto" }] },
      { id: "wamba", name: "Wamba", areas: [{ id: "wamba-main", name: "Wamba" }] },
    ],
  },
  {
    id: "niger",
    name: "Niger State",
    capital: "Minna",
    lgas: [
      { id: "agaie", name: "Agaie", areas: [{ id: "agaie-main", name: "Agaie" }] },
      { id: "agwara", name: "Agwara", areas: [{ id: "agwara-main", name: "Agwara" }] },
      { id: "bida", name: "Bida", areas: [{ id: "bida-main", name: "Bida" }] },
      { id: "borgu", name: "Borgu", areas: [{ id: "new-bussa", name: "New Bussa" }] },
      { id: "bosso", name: "Bosso", areas: [{ id: "bosso-main", name: "Bosso" }] },
      { id: "chanchaga", name: "Chanchaga", areas: [{ id: "minna-main", name: "Minna" }] },
      { id: "edati", name: "Edati", areas: [{ id: "edati-main", name: "Edati" }] },
      { id: "gbako", name: "Gbako", areas: [{ id: "gbako-main", name: "Gbako" }] },
      { id: "gurara", name: "Gurara", areas: [{ id: "gurara-main", name: "Gurara" }] },
      { id: "katcha", name: "Katcha", areas: [{ id: "katcha-main", name: "Katcha" }] },
      { id: "kontagora", name: "Kontagora", areas: [{ id: "kontagora-main", name: "Kontagora" }] },
      { id: "lapai", name: "Lapai", areas: [{ id: "lapai-main", name: "Lapai" }] },
      { id: "lavun", name: "Lavun", areas: [{ id: "lavun-main", name: "Lavun" }] },
      { id: "magama", name: "Magama", areas: [{ id: "magama-main", name: "Magama" }] },
      { id: "mariga", name: "Mariga", areas: [{ id: "mariga-main", name: "Mariga" }] },
      { id: "mashegu", name: "Mashegu", areas: [{ id: "mashegu-main", name: "Mashegu" }] },
      { id: "mokwa", name: "Mokwa", areas: [{ id: "mokwa-main", name: "Mokwa" }] },
      { id: "munya", name: "Munya", areas: [{ id: "munya-main", name: "Munya" }] },
      { id: "paikoro", name: "Paikoro", areas: [{ id: "paikoro-main", name: "Paikoro" }] },
      { id: "rafi", name: "Rafi", areas: [{ id: "kagara", name: "Kagara" }] },
      { id: "rijau", name: "Rijau", areas: [{ id: "rijau-main", name: "Rijau" }] },
      { id: "shiroro", name: "Shiroro", areas: [{ id: "shiroro-main", name: "Shiroro" }] },
      { id: "suleja", name: "Suleja", areas: [{ id: "suleja-main", name: "Suleja" }] },
      { id: "tafa", name: "Tafa", areas: [{ id: "tafa-main", name: "Tafa" }] },
      { id: "wushishi", name: "Wushishi", areas: [{ id: "wushishi-main", name: "Wushishi" }] },
    ],
  },
  {
    id: "ogun",
    name: "Ogun State",
    capital: "Abeokuta",
    lgas: [
      { id: "abeokuta-north", name: "Abeokuta North", areas: [{ id: "abeokuta-main", name: "Abeokuta" }, { id: "onikolobo", name: "Onikolobo" }] },
      { id: "abeokuta-south", name: "Abeokuta South", areas: [{ id: "kuto", name: "Kuto" }, { id: "ita-eko", name: "Ita Eko" }] },
      { id: "ado-odo-ota", name: "Ado-Odo/Ota", areas: [{ id: "ota", name: "Ota" }, { id: "sango-ota", name: "Sango-Ota" }, { id: "agbara", name: "Agbara" }] },
      { id: "ewekoro", name: "Ewekoro", areas: [{ id: "ewekoro-main", name: "Ewekoro" }] },
      { id: "ifo", name: "Ifo", areas: [{ id: "ifo-main", name: "Ifo" }] },
      { id: "ijebu-east", name: "Ijebu East", areas: [{ id: "ogbere", name: "Ogbere" }] },
      { id: "ijebu-north", name: "Ijebu North", areas: [{ id: "ijebu-igbo", name: "Ijebu-Igbo" }] },
      { id: "ijebu-north-east", name: "Ijebu North East", areas: [{ id: "atan", name: "Atan" }] },
      { id: "ijebu-ode", name: "Ijebu Ode", areas: [{ id: "ijebu-ode-main", name: "Ijebu Ode" }] },
      { id: "ikenne", name: "Ikenne", areas: [{ id: "ikenne-main", name: "Ikenne" }] },
      { id: "imeko-afon", name: "Imeko Afon", areas: [{ id: "imeko", name: "Imeko" }] },
      { id: "ipokia", name: "Ipokia", areas: [{ id: "ipokia-main", name: "Ipokia" }] },
      { id: "obafemi-owode", name: "Obafemi Owode", areas: [{ id: "owode", name: "Owode" }, { id: "mowe", name: "Mowe" }, { id: "ofada", name: "Ofada" }] },
      { id: "odeda", name: "Odeda", areas: [{ id: "odeda-main", name: "Odeda" }] },
      { id: "odogbolu", name: "Odogbolu", areas: [{ id: "odogbolu-main", name: "Odogbolu" }] },
      { id: "ogun-waterside", name: "Ogun Waterside", areas: [{ id: "abigi", name: "Abigi" }] },
      { id: "remo-north", name: "Remo North", areas: [{ id: "isara", name: "Isara" }] },
      { id: "sagamu", name: "Sagamu", areas: [{ id: "sagamu-main", name: "Sagamu" }] },
      { id: "yewa-north", name: "Yewa North", areas: [{ id: "ayetoro", name: "Ayetoro" }] },
      { id: "yewa-south", name: "Yewa South", areas: [{ id: "ilaro", name: "Ilaro" }] },
    ],
  },
  {
    id: "ondo",
    name: "Ondo State",
    capital: "Akure",
    lgas: [
      { id: "akoko-north-east", name: "Akoko North-East", areas: [{ id: "ikare", name: "Ikare" }] },
      { id: "akoko-north-west", name: "Akoko North-West", areas: [{ id: "okeagbe", name: "Okeagbe" }] },
      { id: "akoko-south-east", name: "Akoko South-East", areas: [{ id: "isua", name: "Isua" }] },
      { id: "akoko-south-west", name: "Akoko South-West", areas: [{ id: "oka", name: "Oka" }] },
      { id: "akure-north", name: "Akure North", areas: [{ id: "iju", name: "Iju" }] },
      { id: "akure-south", name: "Akure South", areas: [{ id: "akure-main", name: "Akure" }, { id: "alagbaka", name: "Alagbaka" }] },
      { id: "ese-odo", name: "Ese Odo", areas: [{ id: "igbekebo", name: "Igbekebo" }] },
      { id: "idanre", name: "Idanre", areas: [{ id: "idanre-main", name: "Idanre" }] },
      { id: "ifedore", name: "Ifedore", areas: [{ id: "igbara-oke", name: "Igbara-Oke" }] },
      { id: "ilaje", name: "Ilaje", areas: [{ id: "igbokoda", name: "Igbokoda" }] },
      { id: "ile-oluji-okeigbo", name: "Ile Oluji/Okeigbo", areas: [{ id: "ile-oluji", name: "Ile-Oluji" }] },
      { id: "irele", name: "Irele", areas: [{ id: "ode-irele", name: "Ode Irele" }] },
      { id: "odigbo", name: "Odigbo", areas: [{ id: "ore", name: "Ore" }] },
      { id: "okitipupa", name: "Okitipupa", areas: [{ id: "okitipupa-main", name: "Okitipupa" }] },
      { id: "ondo-east", name: "Ondo East", areas: [{ id: "bolorunduro", name: "Bolorunduro" }] },
      { id: "ondo-west", name: "Ondo West", areas: [{ id: "ondo-main", name: "Ondo" }] },
      { id: "ose", name: "Ose", areas: [{ id: "ifon", name: "Ifon" }] },
      { id: "owo", name: "Owo", areas: [{ id: "owo-main", name: "Owo" }] },
    ],
  },
  {
    id: "osun",
    name: "Osun State",
    capital: "Osogbo",
    lgas: [
      { id: "aiyedade", name: "Aiyedade", areas: [{ id: "gbongan", name: "Gbongan" }] },
      { id: "aiyedire", name: "Aiyedire", areas: [{ id: "ile-ogbo", name: "Ile-Ogbo" }] },
      { id: "atakumosa-east", name: "Atakumosa East", areas: [{ id: "ipetu-ijesa", name: "Ipetu-Ijesa" }] },
      { id: "atakumosa-west", name: "Atakumosa West", areas: [{ id: "osu", name: "Osu" }] },
      { id: "boluwaduro", name: "Boluwaduro", areas: [{ id: "otan-ayegbaju", name: "Otan Ayegbaju" }] },
      { id: "boripe", name: "Boripe", areas: [{ id: "iragbiji", name: "Iragbiji" }] },
      { id: "ede-north", name: "Ede North", areas: [{ id: "ede-main", name: "Ede" }] },
      { id: "ede-south", name: "Ede South", areas: [{ id: "ede-south", name: "Ede South" }] },
      { id: "egbedore", name: "Egbedore", areas: [{ id: "awo", name: "Awo" }] },
      { id: "ejigbo", name: "Ejigbo", areas: [{ id: "ejigbo-main", name: "Ejigbo" }] },
      { id: "ife-central", name: "Ife Central", areas: [{ id: "ile-ife", name: "Ile-Ife" }] },
      { id: "ife-east", name: "Ife East", areas: [{ id: "oke-ogbo", name: "Oke Ogbo" }] },
      { id: "ife-north", name: "Ife North", areas: [{ id: "ipetumodu", name: "Ipetumodu" }] },
      { id: "ife-south", name: "Ife South", areas: [{ id: "ifetedo", name: "Ifetedo" }] },
      { id: "ifedayo", name: "Ifedayo", areas: [{ id: "oke-ila", name: "Oke-Ila" }] },
      { id: "ifelodun-osun", name: "Ifelodun", areas: [{ id: "ikirun", name: "Ikirun" }] },
      { id: "ila", name: "Ila", areas: [{ id: "ila-orangun", name: "Ila Orangun" }] },
      { id: "ilesa-east", name: "Ilesa East", areas: [{ id: "ilesa-main", name: "Ilesa" }] },
      { id: "ilesa-west", name: "Ilesa West", areas: [{ id: "ilesa-west", name: "Ilesa West" }] },
      { id: "irepodun-osun", name: "Irepodun", areas: [{ id: "ilobu", name: "Ilobu" }] },
      { id: "irewole", name: "Irewole", areas: [{ id: "ikire", name: "Ikire" }] },
      { id: "isokan", name: "Isokan", areas: [{ id: "apomu", name: "Apomu" }] },
      { id: "iwo", name: "Iwo", areas: [{ id: "iwo-main", name: "Iwo" }] },
      { id: "obokun", name: "Obokun", areas: [{ id: "ibokun", name: "Ibokun" }] },
      { id: "odo-otin", name: "Odo-Otin", areas: [{ id: "okuku", name: "Okuku" }] },
      { id: "ola-oluwa", name: "Ola Oluwa", areas: [{ id: "bode-osi", name: "Bode Osi" }] },
      { id: "olorunda", name: "Olorunda", areas: [{ id: "igbonna", name: "Igbonna" }] },
      { id: "oriade", name: "Oriade", areas: [{ id: "ijebu-jesa", name: "Ijebu-Jesa" }] },
      { id: "orolu", name: "Orolu", areas: [{ id: "ifon-osun", name: "Ifon Osun" }] },
      { id: "osogbo", name: "Osogbo", areas: [{ id: "osogbo-main", name: "Osogbo" }, { id: "oke-baale", name: "Oke Baale" }] },
    ],
  },
  {
    id: "oyo",
    name: "Oyo State",
    capital: "Ibadan",
    lgas: [
      { id: "afijio", name: "Afijio", areas: [{ id: "jobele", name: "Jobele" }] },
      { id: "akinyele", name: "Akinyele", areas: [{ id: "moniya", name: "Moniya" }] },
      { id: "atiba", name: "Atiba", areas: [{ id: "ofa-meta", name: "Ofa Meta" }] },
      { id: "atisbo", name: "Atisbo", areas: [{ id: "ago-are", name: "Ago-Are" }] },
      { id: "egbeda", name: "Egbeda", areas: [{ id: "egbeda-oyo", name: "Egbeda" }] },
      { id: "ibadan-north", name: "Ibadan North", areas: [{ id: "bodija", name: "Bodija" }, { id: "agodi", name: "Agodi" }, { id: "ui", name: "University of Ibadan" }, { id: "sango-ibadan", name: "Sango" }] },
      { id: "ibadan-north-east", name: "Ibadan North-East", areas: [{ id: "iwo-road", name: "Iwo Road" }] },
      { id: "ibadan-north-west", name: "Ibadan North-West", areas: [{ id: "dugbe", name: "Dugbe" }] },
      { id: "ibadan-south-east", name: "Ibadan South-East", areas: [{ id: "mapo", name: "Mapo" }] },
      { id: "ibadan-south-west", name: "Ibadan South-West", areas: [{ id: "ring-road-ibadan", name: "Ring Road" }, { id: "challenge-ibadan", name: "Challenge" }, { id: "oluyole", name: "Oluyole" }] },
      { id: "ibarapa-central", name: "Ibarapa Central", areas: [{ id: "igbo-ora", name: "Igbo-Ora" }] },
      { id: "ibarapa-east", name: "Ibarapa East", areas: [{ id: "eruwa", name: "Eruwa" }] },
      { id: "ibarapa-north", name: "Ibarapa North", areas: [{ id: "ayete", name: "Ayete" }] },
      { id: "ido", name: "Ido", areas: [{ id: "ido-main", name: "Ido" }] },
      { id: "irepo", name: "Irepo", areas: [{ id: "kisi", name: "Kisi" }] },
      { id: "iseyin", name: "Iseyin", areas: [{ id: "iseyin-main", name: "Iseyin" }] },
      { id: "itesiwaju", name: "Itesiwaju", areas: [{ id: "otu", name: "Otu" }] },
      { id: "iwajowa", name: "Iwajowa", areas: [{ id: "iwere-ile", name: "Iwere-Ile" }] },
      { id: "kajola", name: "Kajola", areas: [{ id: "okeho", name: "Okeho" }] },
      { id: "lagelu", name: "Lagelu", areas: [{ id: "iyana-offa", name: "Iyana Offa" }] },
      { id: "ogo-oluwa", name: "Ogo Oluwa", areas: [{ id: "ajaawa", name: "Ajaawa" }] },
      { id: "ogbomosho-north", name: "Ogbomosho North", areas: [{ id: "ogbomosho-main", name: "Ogbomosho" }] },
      { id: "ogbomosho-south", name: "Ogbomosho South", areas: [{ id: "ogbomosho-south", name: "Ogbomosho South" }] },
      { id: "olorunsogo", name: "Olorunsogo", areas: [{ id: "igbeti", name: "Igbeti" }] },
      { id: "oluyole", name: "Oluyole", areas: [{ id: "oluyole-main", name: "Oluyole" }] },
      { id: "ona-ara", name: "Ona Ara", areas: [{ id: "akanran", name: "Akanran" }] },
      { id: "orelope", name: "Orelope", areas: [{ id: "igboho", name: "Igboho" }] },
      { id: "ori-ire", name: "Ori Ire", areas: [{ id: "ikoyi-ile", name: "Ikoyi-Ile" }] },
      { id: "oyo-east", name: "Oyo East", areas: [{ id: "kosobo", name: "Kosobo" }] },
      { id: "oyo-west", name: "Oyo West", areas: [{ id: "oyo-main", name: "Oyo" }] },
      { id: "saki-east", name: "Saki East", areas: [{ id: "ago-amodu", name: "Ago Amodu" }] },
      { id: "saki-west", name: "Saki West", areas: [{ id: "saki-main", name: "Saki" }] },
      { id: "surulere-oyo", name: "Surulere", areas: [{ id: "iresa-adu", name: "Iresa-Adu" }] },
    ],
  },
  {
    id: "plateau",
    name: "Plateau State",
    capital: "Jos",
    lgas: [
      { id: "barkin-ladi", name: "Barkin Ladi", areas: [{ id: "barkin-ladi-main", name: "Barkin Ladi" }] },
      { id: "bassa-plateau", name: "Bassa", areas: [{ id: "bassa-plateau-main", name: "Bassa" }] },
      { id: "bokkos", name: "Bokkos", areas: [{ id: "bokkos-main", name: "Bokkos" }] },
      { id: "jos-east", name: "Jos East", areas: [{ id: "angware", name: "Angware" }] },
      { id: "jos-north", name: "Jos North", areas: [{ id: "jos-main", name: "Jos" }, { id: "terminus", name: "Terminus" }] },
      { id: "jos-south", name: "Jos South", areas: [{ id: "bukuru", name: "Bukuru" }] },
      { id: "kanam", name: "Kanam", areas: [{ id: "kanam-main", name: "Kanam" }] },
      { id: "kanke", name: "Kanke", areas: [{ id: "kanke-main", name: "Kanke" }] },
      { id: "langtang-north", name: "Langtang North", areas: [{ id: "langtang-main", name: "Langtang" }] },
      { id: "langtang-south", name: "Langtang South", areas: [{ id: "langtang-south-main", name: "Langtang South" }] },
      { id: "mangu", name: "Mangu", areas: [{ id: "mangu-main", name: "Mangu" }] },
      { id: "mikang", name: "Mikang", areas: [{ id: "mikang-main", name: "Mikang" }] },
      { id: "pankshin", name: "Pankshin", areas: [{ id: "pankshin-main", name: "Pankshin" }] },
      { id: "quaan-pan", name: "Qua'an Pan", areas: [{ id: "quaan-pan-main", name: "Qua'an Pan" }] },
      { id: "riyom", name: "Riyom", areas: [{ id: "riyom-main", name: "Riyom" }] },
      { id: "shendam", name: "Shendam", areas: [{ id: "shendam-main", name: "Shendam" }] },
      { id: "wase", name: "Wase", areas: [{ id: "wase-main", name: "Wase" }] },
    ],
  },
  {
    id: "rivers",
    name: "Rivers State",
    capital: "Port Harcourt",
    lgas: [
      { id: "abua-odual", name: "Abua/Odual", areas: [{ id: "abua-main", name: "Abua" }] },
      { id: "ahoada-east", name: "Ahoada East", areas: [{ id: "ahoada-main", name: "Ahoada" }] },
      { id: "ahoada-west", name: "Ahoada West", areas: [{ id: "ahoada-west-main", name: "Ahoada West" }] },
      { id: "akuku-toru", name: "Akuku Toru", areas: [{ id: "abonnema", name: "Abonnema" }] },
      { id: "andoni", name: "Andoni", areas: [{ id: "andoni-main", name: "Andoni" }] },
      { id: "asari-toru", name: "Asari-Toru", areas: [{ id: "buguma", name: "Buguma" }] },
      { id: "bonny", name: "Bonny", areas: [{ id: "bonny-main", name: "Bonny" }] },
      { id: "degema", name: "Degema", areas: [{ id: "degema-main", name: "Degema" }] },
      { id: "eleme", name: "Eleme", areas: [{ id: "eleme-main", name: "Eleme" }] },
      { id: "emohua", name: "Emohua", areas: [{ id: "emohua-main", name: "Emohua" }] },
      { id: "etche", name: "Etche", areas: [{ id: "okehi-etche", name: "Okehi" }] },
      { id: "gokana", name: "Gokana", areas: [{ id: "kpor", name: "Kpor" }] },
      { id: "ikwerre", name: "Ikwerre", areas: [{ id: "isiokpo", name: "Isiokpo" }] },
      { id: "khana", name: "Khana", areas: [{ id: "bori", name: "Bori" }] },
      { id: "obio-akpor", name: "Obio/Akpor", areas: [{ id: "rumuokoro", name: "Rumuokoro" }, { id: "rukpokwu", name: "Rukpokwu" }, { id: "eliozu", name: "Eliozu" }, { id: "rumuigbo", name: "Rumuigbo" }] },
      { id: "ogba-egbema-ndoni", name: "Ogba/Egbema/Ndoni", areas: [{ id: "omoku", name: "Omoku" }] },
      { id: "ogu-bolo", name: "Ogu/Bolo", areas: [{ id: "ogu-main", name: "Ogu" }] },
      { id: "okrika", name: "Okrika", areas: [{ id: "okrika-main", name: "Okrika" }] },
      { id: "omuma", name: "Omuma", areas: [{ id: "omuma-main", name: "Omuma" }] },
      { id: "opobo-nkoro", name: "Opobo/Nkoro", areas: [{ id: "opobo", name: "Opobo" }] },
      { id: "oyigbo", name: "Oyigbo", areas: [{ id: "oyigbo-main", name: "Oyigbo" }] },
      { id: "port-harcourt", name: "Port Harcourt", areas: [{ id: "gra-ph", name: "GRA Phase 1" }, { id: "gra-ph-2", name: "GRA Phase 2" }, { id: "dline", name: "D-Line" }, { id: "trans-amadi", name: "Trans Amadi" }, { id: "old-gra", name: "Old GRA" }] },
      { id: "tai", name: "Tai", areas: [{ id: "tai-main", name: "Tai" }] },
    ],
  },
  {
    id: "sokoto",
    name: "Sokoto State",
    capital: "Sokoto",
    lgas: [
      { id: "binji", name: "Binji", areas: [{ id: "binji-main", name: "Binji" }] },
      { id: "bodinga", name: "Bodinga", areas: [{ id: "bodinga-main", name: "Bodinga" }] },
      { id: "dange-shuni", name: "Dange Shuni", areas: [{ id: "dange-main", name: "Dange" }] },
      { id: "gada", name: "Gada", areas: [{ id: "gada-main", name: "Gada" }] },
      { id: "goronyo", name: "Goronyo", areas: [{ id: "goronyo-main", name: "Goronyo" }] },
      { id: "gudu", name: "Gudu", areas: [{ id: "gudu-main", name: "Gudu" }] },
      { id: "gwadabawa", name: "Gwadabawa", areas: [{ id: "gwadabawa-main", name: "Gwadabawa" }] },
      { id: "illela", name: "Illela", areas: [{ id: "illela-main", name: "Illela" }] },
      { id: "isa", name: "Isa", areas: [{ id: "isa-main", name: "Isa" }] },
      { id: "kebbe", name: "Kebbe", areas: [{ id: "kebbe-main", name: "Kebbe" }] },
      { id: "kware", name: "Kware", areas: [{ id: "kware-main", name: "Kware" }] },
      { id: "rabah", name: "Rabah", areas: [{ id: "rabah-main", name: "Rabah" }] },
      { id: "sabon-birni", name: "Sabon Birni", areas: [{ id: "sabon-birni-main", name: "Sabon Birni" }] },
      { id: "shagari", name: "Shagari", areas: [{ id: "shagari-main", name: "Shagari" }] },
      { id: "silame", name: "Silame", areas: [{ id: "silame-main", name: "Silame" }] },
      { id: "sokoto-north", name: "Sokoto North", areas: [{ id: "sokoto-main", name: "Sokoto" }] },
      { id: "sokoto-south", name: "Sokoto South", areas: [{ id: "sokoto-south", name: "Sokoto South" }] },
      { id: "tambuwal", name: "Tambuwal", areas: [{ id: "tambuwal-main", name: "Tambuwal" }] },
      { id: "tangaza", name: "Tangaza", areas: [{ id: "tangaza-main", name: "Tangaza" }] },
      { id: "tureta", name: "Tureta", areas: [{ id: "tureta-main", name: "Tureta" }] },
      { id: "wamako", name: "Wamako", areas: [{ id: "wamako-main", name: "Wamako" }] },
      { id: "wurno", name: "Wurno", areas: [{ id: "wurno-main", name: "Wurno" }] },
      { id: "yabo", name: "Yabo", areas: [{ id: "yabo-main", name: "Yabo" }] },
    ],
  },
  {
    id: "taraba",
    name: "Taraba State",
    capital: "Jalingo",
    lgas: [
      { id: "ardo-kola", name: "Ardo Kola", areas: [{ id: "ardo-kola-main", name: "Ardo Kola" }] },
      { id: "bali", name: "Bali", areas: [{ id: "bali-main", name: "Bali" }] },
      { id: "donga", name: "Donga", areas: [{ id: "donga-main", name: "Donga" }] },
      { id: "gashaka", name: "Gashaka", areas: [{ id: "gashaka-main", name: "Gashaka" }] },
      { id: "gassol", name: "Gassol", areas: [{ id: "gassol-main", name: "Gassol" }] },
      { id: "ibi", name: "Ibi", areas: [{ id: "ibi-main", name: "Ibi" }] },
      { id: "jalingo", name: "Jalingo", areas: [{ id: "jalingo-main", name: "Jalingo" }] },
      { id: "karim-lamido", name: "Karim Lamido", areas: [{ id: "karim-lamido-main", name: "Karim Lamido" }] },
      { id: "kumi", name: "Kumi", areas: [{ id: "kumi-main", name: "Kumi" }] },
      { id: "lau", name: "Lau", areas: [{ id: "lau-main", name: "Lau" }] },
      { id: "sardauna", name: "Sardauna", areas: [{ id: "gembu", name: "Gembu" }] },
      { id: "takum", name: "Takum", areas: [{ id: "takum-main", name: "Takum" }] },
      { id: "ussa", name: "Ussa", areas: [{ id: "ussa-main", name: "Ussa" }] },
      { id: "wukari", name: "Wukari", areas: [{ id: "wukari-main", name: "Wukari" }] },
      { id: "yorro", name: "Yorro", areas: [{ id: "yorro-main", name: "Yorro" }] },
      { id: "zing", name: "Zing", areas: [{ id: "zing-main", name: "Zing" }] },
    ],
  },
  {
    id: "yobe",
    name: "Yobe State",
    capital: "Damaturu",
    lgas: [
      { id: "bade", name: "Bade", areas: [{ id: "gashua", name: "Gashua" }] },
      { id: "bursari", name: "Bursari", areas: [{ id: "bursari-main", name: "Bursari" }] },
      { id: "damaturu", name: "Damaturu", areas: [{ id: "damaturu-main", name: "Damaturu" }] },
      { id: "fika", name: "Fika", areas: [{ id: "fika-main", name: "Fika" }] },
      { id: "fune", name: "Fune", areas: [{ id: "fune-main", name: "Fune" }] },
      { id: "geidam", name: "Geidam", areas: [{ id: "geidam-main", name: "Geidam" }] },
      { id: "gujba", name: "Gujba", areas: [{ id: "gujba-main", name: "Gujba" }] },
      { id: "gulani", name: "Gulani", areas: [{ id: "gulani-main", name: "Gulani" }] },
      { id: "jakusko", name: "Jakusko", areas: [{ id: "jakusko-main", name: "Jakusko" }] },
      { id: "karasuwa", name: "Karasuwa", areas: [{ id: "karasuwa-main", name: "Karasuwa" }] },
      { id: "machina", name: "Machina", areas: [{ id: "machina-main", name: "Machina" }] },
      { id: "nangere", name: "Nangere", areas: [{ id: "nangere-main", name: "Nangere" }] },
      { id: "nguru", name: "Nguru", areas: [{ id: "nguru-main", name: "Nguru" }] },
      { id: "potiskum", name: "Potiskum", areas: [{ id: "potiskum-main", name: "Potiskum" }] },
      { id: "tarmuwa", name: "Tarmuwa", areas: [{ id: "tarmuwa-main", name: "Tarmuwa" }] },
      { id: "yunusari", name: "Yunusari", areas: [{ id: "yunusari-main", name: "Yunusari" }] },
      { id: "yusufari", name: "Yusufari", areas: [{ id: "yusufari-main", name: "Yusufari" }] },
    ],
  },
  {
    id: "zamfara",
    name: "Zamfara State",
    capital: "Gusau",
    lgas: [
      { id: "anka", name: "Anka", areas: [{ id: "anka-main", name: "Anka" }] },
      { id: "bakura", name: "Bakura", areas: [{ id: "bakura-main", name: "Bakura" }] },
      { id: "birnin-magaji-kiyaw", name: "Birnin Magaji/Kiyaw", areas: [{ id: "birnin-magaji-main", name: "Birnin Magaji" }] },
      { id: "bukkuyum", name: "Bukkuyum", areas: [{ id: "bukkuyum-main", name: "Bukkuyum" }] },
      { id: "bungudu", name: "Bungudu", areas: [{ id: "bungudu-main", name: "Bungudu" }] },
      { id: "gummi", name: "Gummi", areas: [{ id: "gummi-main", name: "Gummi" }] },
      { id: "gusau", name: "Gusau", areas: [{ id: "gusau-main", name: "Gusau" }] },
      { id: "kaura-namoda", name: "Kaura Namoda", areas: [{ id: "kaura-namoda-main", name: "Kaura Namoda" }] },
      { id: "maradun", name: "Maradun", areas: [{ id: "maradun-main", name: "Maradun" }] },
      { id: "maru", name: "Maru", areas: [{ id: "maru-main", name: "Maru" }] },
      { id: "shinkafi", name: "Shinkafi", areas: [{ id: "shinkafi-main", name: "Shinkafi" }] },
      { id: "talata-mafara", name: "Talata Mafara", areas: [{ id: "talata-mafara-main", name: "Talata Mafara" }] },
      { id: "tsafe", name: "Tsafe", areas: [{ id: "tsafe-main", name: "Tsafe" }] },
      { id: "zurmi", name: "Zurmi", areas: [{ id: "zurmi-main", name: "Zurmi" }] },
    ],
  },
  {
    id: "fct",
    name: "FCT Abuja",
    capital: "Abuja",
    lgas: [
      { id: "abaji", name: "Abaji", areas: [{ id: "abaji-main", name: "Abaji" }] },
      { id: "abuja-municipal", name: "Abuja Municipal (AMAC)", areas: [{ id: "wuse", name: "Wuse" }, { id: "wuse-2", name: "Wuse 2" }, { id: "garki", name: "Garki" }, { id: "maitama", name: "Maitama" }, { id: "asokoro", name: "Asokoro" }, { id: "central-area", name: "Central Area" }, { id: "utako", name: "Utako" }, { id: "jabi", name: "Jabi" }] },
      { id: "bwari", name: "Bwari", areas: [{ id: "bwari-main", name: "Bwari" }, { id: "dutse", name: "Dutse" }, { id: "kubwa", name: "Kubwa" }] },
      { id: "gwagwalada", name: "Gwagwalada", areas: [{ id: "gwagwalada-main", name: "Gwagwalada" }] },
      { id: "kuje", name: "Kuje", areas: [{ id: "kuje-main", name: "Kuje" }] },
      { id: "kwali", name: "Kwali", areas: [{ id: "kwali-main", name: "Kwali" }] },
    ],
  },
];

// Helper function to get all states for dropdown
export const getAllStates = () => nigeriaStates.map(state => ({ id: state.id, name: state.name }));

// Helper function to get LGAs for a state
export const getLGAsByState = (stateId: string) => {
  const state = nigeriaStates.find(s => s.id === stateId);
  return state?.lgas || [];
};

// Helper function to get areas for an LGA
export const getAreasByLGA = (stateId: string, lgaId: string) => {
  const state = nigeriaStates.find(s => s.id === stateId);
  const lga = state?.lgas.find(l => l.id === lgaId);
  return lga?.areas || [];
};

// Popular locations for display
export const popularLocations = [
  { state: "Lagos State", area: "Lekki", count: 2450 },
  { state: "Lagos State", area: "Ikeja", count: 1980 },
  { state: "FCT Abuja", area: "Wuse", count: 1520 },
  { state: "Lagos State", area: "Victoria Island", count: 1350 },
  { state: "FCT Abuja", area: "Gwarinpa", count: 1140 },
  { state: "Rivers State", area: "Port Harcourt", count: 980 },
  { state: "Oyo State", area: "Ibadan", count: 860 },
  { state: "Kano State", area: "Kano", count: 720 },
  { state: "Lagos State", area: "Ajah", count: 680 },
  { state: "Delta State", area: "Warri", count: 540 },
  { state: "Ogun State", area: "Abeokuta", count: 480 },
  { state: "Enugu State", area: "Enugu", count: 420 },
];

// Popular areas for search suggestions (across all states)
export const popularAreas = [
  { id: "lekki", name: "Lekki", state: "lagos", stateLabel: "Lagos" },
  { id: "ikeja", name: "Ikeja", state: "lagos", stateLabel: "Lagos" },
  { id: "victoria-island", name: "Victoria Island", state: "lagos", stateLabel: "Lagos" },
  { id: "ajah", name: "Ajah", state: "lagos", stateLabel: "Lagos" },
  { id: "surulere", name: "Surulere", state: "lagos", stateLabel: "Lagos" },
  { id: "yaba", name: "Yaba", state: "lagos", stateLabel: "Lagos" },
  { id: "ikoyi", name: "Ikoyi", state: "lagos", stateLabel: "Lagos" },
  { id: "wuse", name: "Wuse", state: "fct", stateLabel: "Abuja" },
  { id: "gwarinpa", name: "Gwarinpa", state: "fct", stateLabel: "Abuja" },
  { id: "maitama", name: "Maitama", state: "fct", stateLabel: "Abuja" },
  { id: "asokoro", name: "Asokoro", state: "fct", stateLabel: "Abuja" },
  { id: "garki", name: "Garki", state: "fct", stateLabel: "Abuja" },
  { id: "port-harcourt", name: "Port Harcourt", state: "rivers", stateLabel: "Rivers" },
  { id: "trans-amadi", name: "Trans Amadi", state: "rivers", stateLabel: "Rivers" },
  { id: "ibadan", name: "Ibadan", state: "oyo", stateLabel: "Oyo" },
  { id: "bodija", name: "Bodija", state: "oyo", stateLabel: "Oyo" },
  { id: "kano-city", name: "Kano City", state: "kano", stateLabel: "Kano" },
  { id: "aba", name: "Aba", state: "abia", stateLabel: "Abia" },
  { id: "onitsha", name: "Onitsha", state: "anambra", stateLabel: "Anambra" },
  { id: "benin-city", name: "Benin City", state: "edo", stateLabel: "Edo" },
  { id: "warri", name: "Warri", state: "delta", stateLabel: "Delta" },
  { id: "enugu", name: "Enugu", state: "enugu", stateLabel: "Enugu" },
  { id: "abeokuta", name: "Abeokuta", state: "ogun", stateLabel: "Ogun" },
  { id: "calabar", name: "Calabar", state: "cross-river", stateLabel: "Cross River" },
  { id: "kaduna-city", name: "Kaduna", state: "kaduna", stateLabel: "Kaduna" },
  { id: "jos", name: "Jos", state: "plateau", stateLabel: "Plateau" },
  { id: "maiduguri", name: "Maiduguri", state: "borno", stateLabel: "Borno" },
];

// Get all areas from all states for search
export const getAllAreas = () => {
  const areas: { id: string; name: string; lgaName: string; stateName: string; stateId: string }[] = [];
  nigeriaStates.forEach(state => {
    state.lgas.forEach(lga => {
      lga.areas.forEach(area => {
        areas.push({
          id: area.id,
          name: area.name,
          lgaName: lga.name,
          stateName: state.name,
          stateId: state.id,
        });
      });
    });
  });
  return areas;
};
